(function () {
  var root = document.querySelector('[data-mma-cart-drawer]');
  var configNode = document.querySelector('[data-mma-cart-config]');
  if (!root || !configNode) return;

  var config = {};
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    console.warn('MMA cart config could not be parsed.', error);
    return;
  }
  // Keep the current protection rule authoritative when Shopify serves cached page HTML.
  config.protectionPrice = 100;
  config.protectionDefaultFee = 100;
  config.protectionPercentage = 4;
  config.freeShippingThreshold = Number(config.freeShippingThreshold || 17000);
  config.blackjackOrderThreshold = Number(config.blackjackOrderThreshold || 15000);
  config.blackjackOrderCodeHours = Number(config.blackjackOrderCodeHours || 48);
  config.wrapsGiftThreshold = Number(config.wrapsGiftThreshold || 22000);
  config.mouthGuardGiftThreshold = Number(config.mouthGuardGiftThreshold || 27000);
  config.rewardCampaign = text(config.rewardCampaign || 'cart_ladder_claim_gifts_20260706');

  var panel = root.querySelector('.mma-cart__panel');
  var body = root.querySelector('[data-mma-cart-body]');
  var loading = root.querySelector('[data-mma-cart-loading]');
  var itemsNode = root.querySelector('[data-mma-cart-items]');
  var emptyNode = root.querySelector('[data-mma-cart-empty]');
  var footerNode = root.querySelector('[data-mma-cart-footer]');
  var subtotalNode = root.querySelector('[data-mma-cart-subtotal]');
  var blackjackOfferNode = root.querySelector('[data-mma-blackjack-offer]');
  var blackjackOfferCopy = root.querySelector('[data-mma-blackjack-offer-copy]');
  var protectionPriceNode = root.querySelector('[data-mma-cart-protection-price]');
  var countLabel = root.querySelector('[data-mma-cart-count-label]');
  var rewardCopy = root.querySelector('[data-mma-cart-reward-copy]');
  var progressFill = root.querySelector('[data-mma-cart-progress-fill]');
  var rewardGiftSection = root.querySelector('[data-mma-cart-reward-gifts]');
  var upsellSection = root.querySelector('[data-mma-cart-upsells]');
  var upsellHeading = root.querySelector('[data-mma-cart-upsell-heading]');
  var upsellCard = root.querySelector('[data-mma-cart-upsell-card]');
  var upsellControls = root.querySelector('[data-mma-cart-upsell-controls]');
  var upsellPosition = root.querySelector('[data-mma-upsell-position]');
  var upsellDetails = root.querySelector('[data-mma-upsell-details]');
  var upsellDetailsSheet = root.querySelector('.mma-cart__quick-view-sheet');
  var upsellDetailsContent = root.querySelector('[data-mma-upsell-details-content]');
  var removeConfirm = root.querySelector('[data-mma-remove-confirm]');
  var removeConfirmDialog = root.querySelector('.mma-cart__confirm-dialog');
  var removeConfirmCopy = root.querySelector('[data-mma-remove-copy]');
  var rewardConflict = root.querySelector('[data-mma-reward-conflict]');
  var rewardConflictDialog = root.querySelector('.mma-cart__reward-conflict-dialog');
  var rewardConflictTitle = root.querySelector('[data-mma-reward-conflict-title]');
  var rewardConflictCopy = root.querySelector('[data-mma-reward-conflict-copy]');
  var rewardConflictPrimary = root.querySelector('[data-mma-reward-conflict-primary]');
  var rewardConflictPrimaryLabel = root.querySelector('[data-mma-reward-conflict-primary-label]');
  var rewardConflictPrimaryMeta = root.querySelector('[data-mma-reward-conflict-primary-meta]');
  var rewardConflictPrimaryBadge = root.querySelector('[data-mma-reward-conflict-primary-badge]');
  var rewardConflictSecondary = root.querySelector('[data-mma-reward-conflict-secondary]');
  var rewardConflictSecondaryLabel = root.querySelector('[data-mma-reward-conflict-secondary-label]');
  var rewardConflictSecondaryMeta = root.querySelector('[data-mma-reward-conflict-secondary-meta]');
  var rewardConflictSecondaryBadge = root.querySelector('[data-mma-reward-conflict-secondary-badge]');
  var state = {
    cart: null,
    upsells: [],
    upsellIndex: 0,
    lastFocus: null,
    pendingRemove: null,
    pendingRewardConflict: null,
    salePricingHandles: {},
    variantSalePricing: {},
    seenUpsellViews: {},
    seenRewardViews: {},
    selectedUpsellVariants: {},
    quickViewProduct: null,
    quickViewLastFocus: null,
    quickViewCloseTimer: null,
    upsellsLoaded: false,
    upsellsLoading: null,
    refreshRetryTimer: null,
    refreshRetryCount: 0
  };

  config.protectionVariants = (config.protectionVariants || []).map(function (variant) {
    return {
      id: Number(variant.id),
      price: Number(variant.price || 0),
      title: text(variant.title)
    };
  }).filter(function (variant) {
    return variant.id && variant.price > 0;
  }).sort(function (left, right) {
    return left.price - right.price;
  });

  var protectionVariantIds = {};
  config.protectionVariants.forEach(function (variant) {
    protectionVariantIds[String(variant.id)] = true;
  });

  config.gloveGift = config.gloveGift || {};
  var gloveGiftVariantId = Number(config.gloveGift.variantId || 0);
  var gloveGiftHandle = text(config.gloveGift.handle || '').toLowerCase();
  config.rewardGifts = (config.rewardGifts || []).map(function (gift) {
    var variants = (gift.variants || []).map(function (variant) {
      return {
        id: Number(variant.id),
        title: text(variant.title || ''),
        price: Number(variant.price || 0),
        available: variant.available !== false,
        image: text(variant.image || '')
      };
    }).filter(function (variant) {
      return variant.id && variant.available;
    });
    return {
      tier: Number(gift.tier || 0),
      threshold: Number(gift.threshold || 0),
      code: text(gift.code || ''),
      handle: text(gift.handle || '').toLowerCase(),
      title: text(gift.title || ''),
      shortTitle: text(gift.shortTitle || gift.title || ''),
      lockedCopy: text(gift.lockedCopy || ''),
      claimCopy: text(gift.claimCopy || ''),
      claimedCopy: text(gift.claimedCopy || ''),
      buttonLabel: text(gift.buttonLabel || 'Add free gift'),
      variants: variants
    };
  }).filter(function (gift) {
    return gift.tier && gift.threshold && gift.code && gift.handle && gift.variants.length;
  }).sort(function (left, right) {
    return left.threshold - right.threshold;
  });
  var rewardGiftHandles = {};
  var rewardDiscountCodes = {};
  config.rewardGifts.forEach(function (gift) {
    rewardGiftHandles[gift.handle] = true;
    if (gift.code) rewardDiscountCodes[text(gift.code).toUpperCase()] = true;
  });

  function money(cents) {
    var value = (Number(cents || 0) / 100).toFixed(2);
    return '$' + value;
  }

  function text(value) {
    return String(value == null ? '' : value);
  }

  function html(value) {
    return text(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function itemTitle(item) {
    return text(item.product_title || item.title).replace(' - Default Title', '');
  }

  function searchable(item) {
    return [
      item.product_title,
      item.title,
      item.variant_title,
      item.vendor,
      item.product_type,
      item.handle
    ].join(' ').toLowerCase();
  }

  function hasCartMatch(cart, terms) {
    return visibleItems(cart).some(function (item) {
      if (terms.indexOf('glove') !== -1 && isGloveGift(item)) return false;
      var haystack = searchable(item);
      return terms.some(function (term) {
        return haystack.indexOf(term) !== -1;
      });
    });
  }

  function cartTriggerCategories(cart) {
    var triggers = [];
    if (hasCartMatch(cart, ['glove'])) triggers.push('gloves');
    if (hasCartMatch(cart, ['shin'])) triggers.push('shin_guards');
    if (hasCartMatch(cart, ['short'])) triggers.push('shorts');
    if (visibleItems(cart).some(function (item) {
      var haystack = searchable(item);
      return haystack.indexOf('kick pad') !== -1 ||
        haystack.indexOf('thai pad') !== -1 ||
        haystack.indexOf('belly pad') !== -1 ||
        (haystack.indexOf('pad') !== -1 && haystack.indexOf('shin') === -1 && haystack.indexOf('ankle') === -1);
    })) triggers.push('pads');
    return triggers.length ? triggers.join(',') : 'general';
  }

  function availableVariants(product) {
    var variants = (product && product.variants ? product.variants : []).filter(function (variant) {
      return variant && variant.available !== false;
    });
    if (variants.length) return variants;
    return [{
      id: product.variantId,
      title: product.variantTitle,
      price: product.price,
      image: product.image,
      available: product.available
    }];
  }

  function selectedUpsellVariant(product) {
    var variants = availableVariants(product);
    var select = upsellCard ? upsellCard.querySelector('[data-mma-upsell-variant]') : null;
    var storedId = state.selectedUpsellVariants[text(product && product.handle)];
    var selectedId = Number(storedId || (select ? select.value : product.variantId));
    return variants.find(function (variant) {
      return Number(variant.id) === selectedId;
    }) || variants[0];
  }

  function productRole(product) {
    var handle = text(product && product.handle).toLowerCase();
    var title = text(product && product.title).toLowerCase();
    var type = text(product && product.productType).toLowerCase();
    var haystack = [handle, title, type].join(' ');
    if (haystack.indexOf('wrap') !== -1) return 'wraps';
    if (haystack.indexOf('mouth') !== -1) return 'mouthguard';
    if (haystack.indexOf('ankle') !== -1) return 'ankle';
    if (haystack.indexOf('shin') !== -1) return 'shins';
    if (haystack.indexOf('short') !== -1) return 'shorts';
    if (haystack.indexOf('glove') !== -1 && haystack.indexOf('deodor') === -1) return 'gloves';
    if (haystack.indexOf('kick pad') !== -1 || haystack.indexOf('thai pad') !== -1 || haystack.indexOf('belly pad') !== -1) return 'pads';
    if (haystack.indexOf('bag') !== -1) return 'bag';
    return 'general';
  }

  function cartProfile(cart) {
    return {
      hasGloves: hasCartMatch(cart, ['glove']),
      hasShins: hasCartMatch(cart, ['shin']),
      hasWraps: hasCartMatch(cart, ['wrap']),
      hasMouthguard: hasCartMatch(cart, ['mouth']),
      hasAnkle: hasCartMatch(cart, ['ankle']),
      hasShorts: hasCartMatch(cart, ['short']),
      hasPads: visibleItems(cart).some(function (item) {
        var haystack = searchable(item);
        return haystack.indexOf('kick pad') !== -1 ||
          haystack.indexOf('thai pad') !== -1 ||
          haystack.indexOf('belly pad') !== -1 ||
          (haystack.indexOf('pad') !== -1 && haystack.indexOf('shin') === -1 && haystack.indexOf('ankle') === -1);
      })
    };
  }

  function preferredVariantForThreshold(product, subtotal) {
    var variants = availableVariants(product).slice().sort(function (left, right) {
      return Number(left.price || 0) - Number(right.price || 0);
    });
    if (!variants.length) return null;
    var freeShipping = Number(config.freeShippingThreshold || 17000);
    var gap = freeShipping - subtotal;
    if (gap > 0) {
      var closingVariant = variants.find(function (variant) {
        return Number(variant.price || 0) >= gap;
      });
      if (closingVariant) return closingVariant;
    }
    return variants[0];
  }

  function recommendationReason(role, profile, closesFreeShipping, gap) {
    if (closesFreeShipping) {
      if (role === 'wraps') return 'Useful wraps. Unlocks free shipping.';
      if (role === 'ankle') return 'Ankle support. Unlocks free shipping.';
      if (role === 'mouthguard') return 'Sparring essential. Unlocks free shipping.';
      return 'Completes the setup. Unlocks free shipping.';
    }
    if (gap > 0 && gap <= 3000) return 'Useful add-on. Free shipping is close.';
    if (role === 'wraps') return 'Useful with gloves and shin guards.';
    if (role === 'shins' && profile.hasGloves) return 'Add shin guards to complete the setup.';
    if (role === 'gloves' && profile.hasShins) return 'Add gloves to complete the setup.';
    if (role === 'ankle') return 'Extra support for bag work and Muay Thai.';
    if (role === 'mouthguard') return 'For sparring rounds.';
    if (role === 'shorts') return 'Training shorts matched to your gear.';
    if (role === 'bag') return 'Carry the full setup.';
    return 'Matched to your cart.';
  }

  function recommendationScore(product, cart, profile) {
    var subtotal = visibleSubtotal(cart);
    var freeShipping = Number(config.freeShippingThreshold || 17000);
    var gap = Math.max(0, freeShipping - subtotal);
    var variant = preferredVariantForThreshold(product, subtotal);
    if (!variant) return null;
    var role = productRole(product);
    var price = Number(variant.price || product.price || 0);
    var closesFreeShipping = gap > 0 && price >= gap;
    var score = 0;

    if (gap > 0) {
      if (closesFreeShipping) score += 80;
      if (closesFreeShipping && price <= Math.max(gap + 3000, 3500)) score += 25;
      if (gap <= 3000 && ['wraps', 'ankle', 'mouthguard'].indexOf(role) !== -1) score += 20;
    }

    if (profile.hasGloves) {
      if (role === 'wraps' && !profile.hasWraps) score += 125;
      if (role === 'shins' && !profile.hasShins) score += 80;
      if (role === 'ankle' && !profile.hasAnkle) score += 45;
      if (role === 'mouthguard' && !profile.hasMouthguard) score += 35;
      if (role === 'shorts' && !profile.hasShorts) score += 15;
    }

    if (profile.hasShins) {
      if (role === 'wraps' && !profile.hasWraps) score += 110;
      if (role === 'gloves' && !profile.hasGloves) score += 80;
      if (role === 'ankle' && !profile.hasAnkle) score += 50;
      if (role === 'shorts' && !profile.hasShorts) score += 40;
    }

    if (profile.hasShorts) {
      if (role === 'wraps' && !profile.hasWraps) score += 90;
      if (role === 'shins' && !profile.hasShins) score += 75;
      if (role === 'gloves' && !profile.hasGloves) score += 65;
    }

    if (profile.hasPads) {
      if (role === 'wraps' && !profile.hasWraps) score += 80;
      if (role === 'gloves' && !profile.hasGloves) score += 60;
      if (role === 'bag') score += 25;
    }

    if (!profile.hasGloves && !profile.hasShins && !profile.hasShorts && !profile.hasPads) {
      if (role === 'wraps') score += 45;
      if (role === 'mouthguard' || role === 'ankle') score += 25;
      if (role === 'shins' || role === 'gloves') score += 20;
    }

    if (product.handle === 'twins-special-ch1-hand-wraps') score += 10;
    if (product.handle === 'yokkao-hand-wraps') score += 8;
    if (role === 'gloves' && profile.hasGloves) score -= 70;
    if (role === 'shins' && profile.hasShins) score -= 55;
    if (role === 'wraps' && profile.hasWraps) score -= 80;
    if (role === 'mouthguard' && profile.hasMouthguard) score -= 60;
    if (role === 'ankle' && profile.hasAnkle) score -= 60;

    return {
      score: score,
      role: role,
      variantId: Number(variant.id),
      closesFreeShipping: closesFreeShipping,
      thresholdGap: gap,
      thresholdTarget: closesFreeShipping ? 'free_shipping' : '',
      reason: recommendationReason(role, profile, closesFreeShipping, gap)
    };
  }

  function upsellEventPayload(eventName, product, variant, extra) {
    var recommendation = product._mmaRecommendation || {};
    return Object.assign({
      event: eventName,
      source: 'cart_drawer_upsell',
      campaign: 'custom_cart_drawer',
      product_handle: product.handle,
      product_id: String(product.id),
      product_title: product.title,
      variant_id: String(variant.id),
      variant_title: text(variant.title || ''),
      variant_price: Number(variant.price || product.price || 0) / 100,
      slot: state.upsellIndex + 1,
      rank: String(state.upsellIndex + 1) + '/' + state.upsells.length,
      cart_triggers: cartTriggerCategories(state.cart),
      recommendation_role: text(recommendation.role || productRole(product)),
      recommendation_reason: text(recommendation.reason || ''),
      threshold_gap: Number(recommendation.thresholdGap || 0) / 100,
      closes_free_shipping: Boolean(recommendation.closesFreeShipping),
      threshold_target: text(recommendation.thresholdTarget || ''),
      reward_campaign: text(config.rewardCampaign || ''),
      detail_source: 'card',
      tracking_version: 'cart_drawer_20260819'
    }, extra || {});
  }

  function publishUpsellEvent(eventName, product, variant, extra) {
    var payload = upsellEventPayload(eventName, product, variant, extra);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
    document.dispatchEvent(new CustomEvent('mma:cart-upsell', { detail: payload }));
  }

  function updateUpsellVariantSelection(select) {
    var selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;
    var upsellContainer = select.closest('[data-mma-upsell-handle]');
    var upsellHandle = upsellContainer ? upsellContainer.getAttribute('data-mma-upsell-handle') : '';
    var product = state.upsells.find(function (item) {
      return item.handle === upsellHandle;
    });
    if (!product) return;

    state.selectedUpsellVariants[upsellHandle] = Number(selectedOption.value);
    var selectedVariant = selectedUpsellVariant(product);
    var profile = cartProfile(state.cart);
    var role = productRole(product);
    var gap = Math.max(0, Number(config.freeShippingThreshold || 17000) - visibleSubtotal(state.cart));
    var closes = gap > 0 && Number(selectedVariant.price || 0) >= gap;
    product._mmaRecommendation = Object.assign({}, product._mmaRecommendation || {}, {
      role: role,
      variantId: Number(selectedVariant.id),
      closesFreeShipping: closes,
      thresholdGap: gap,
      thresholdTarget: closes ? 'free_shipping' : '',
      reason: recommendationReason(role, profile, closes, gap)
    });

    root.querySelectorAll('[data-mma-upsell-handle]').forEach(function (container) {
      if (container.getAttribute('data-mma-upsell-handle') !== upsellHandle) return;
      var linkedSelect = container.querySelector('[data-mma-upsell-variant]');
      var priceNode = container.querySelector('[data-mma-upsell-price]');
      var imageNode = container.querySelector('[data-mma-upsell-image]');
      var reasonNode = container.querySelector('[data-mma-upsell-reason]');
      if (linkedSelect && linkedSelect.value !== String(selectedVariant.id)) linkedSelect.value = String(selectedVariant.id);
      if (priceNode) priceNode.textContent = money(selectedVariant.price);
      if (imageNode && selectedVariant.image && imageNode.tagName.toLowerCase() === 'img') {
        imageNode.setAttribute('src', selectedVariant.image);
      }
      if (reasonNode) reasonNode.textContent = product._mmaRecommendation.reason;
    });
  }

  function upsellDetailText(value) {
    if (Array.isArray(value)) {
      return value.map(text).filter(Boolean).join(', ');
    }
    return text(value);
  }

  function hasUpsellDetails(product) {
    var details = (product && product.details) || {};
    var facts = Array.isArray(details.facts) ? details.facts : [];
    return Boolean(text(details.summary)) || facts.some(function (fact) {
      return fact && text(fact.label) && upsellDetailText(fact.value);
    });
  }

  function renderUpsellDetails(product) {
    if (!upsellDetailsContent || !product) return;
    var details = product.details || {};
    var variants = availableVariants(product);
    var selectedVariant = selectedUpsellVariant(product);
    var selectorId = 'mma-upsell-detail-variant-' + product.handle;
    var summary = text(details.summary);
    var detailRows = (Array.isArray(details.facts) ? details.facts : []).slice(0, 4).map(function (fact) {
      var label = fact && text(fact.label);
      var value = fact && upsellDetailText(fact.value);
      if (!label || !value) return '';
      return '<div><dt>' + html(label) + '</dt><dd>' + html(value) + '</dd></div>';
    }).join('');
    var hasVariantOptions = variants.length > 1;
    var variantSelect = hasVariantOptions ? [
      '<div class="mma-cart__quick-view-field">',
      '<label class="mma-cart__quick-view-option-label" for="' + html(selectorId) + '">Choose an option</label>',
      '<select id="' + html(selectorId) + '" class="mma-cart__quick-view-select" data-mma-upsell-variant>',
      variants.map(function (variant) {
        return '<option value="' + html(variant.id) + '" data-price="' + html(variant.price) + '" data-image="' + html(variant.image || product.image || '') + '"' + (Number(variant.id) === Number(selectedVariant.id) ? ' selected' : '') + '>' + html(variant.title) + '</option>';
      }).join(''),
      '</select>',
      '</div>'
    ].join('') : '';
    var actionClass = 'mma-cart__quick-view-actions' + (hasVariantOptions ? '' : ' mma-cart__quick-view-actions--single');

    upsellDetailsContent.innerHTML = [
      '<article class="mma-cart__quick-view-product" data-mma-upsell-handle="' + html(product.handle) + '">',
      '<div class="mma-cart__quick-view-summary">',
      (selectedVariant.image || product.image) ? '<img class="mma-cart__quick-view-image" src="' + html(selectedVariant.image || product.image) + '" alt="' + html(product.title) + '" loading="lazy" data-mma-upsell-image>' : '<div class="mma-cart__quick-view-image" data-mma-upsell-image></div>',
      '<div class="mma-cart__quick-view-name">',
      '<h3 id="mma-cart-quick-view-title">' + html(product.title) + '</h3>',
      '<strong data-mma-upsell-price>' + money(selectedVariant.price) + '</strong>',
      '</div>',
      '</div>',
      '<p class="mma-cart__quick-view-reason" data-mma-upsell-reason>' + html((product._mmaRecommendation || {}).reason || '') + '</p>',
      summary ? '<p class="mma-cart__quick-view-description">' + html(summary) + '</p>' : '',
      detailRows ? '<dl class="mma-cart__quick-view-specs">' + detailRows + '</dl>' : '',
      '<div class="' + actionClass + '">',
      variantSelect,
      '<button type="button" class="mma-cart__quick-view-add" data-mma-add-upsell="' + html(product.handle) + '">ADD TO CART</button>',
      '<a href="' + html(product.url) + '" class="mma-cart__quick-view-link" data-mma-upsell-full-details>View product</a>',
      '</div>',
      '</article>'
    ].join('');
  }

  function openUpsellDetails(product, trigger) {
    if (!upsellDetails || !upsellDetailsSheet || !product || !hasUpsellDetails(product)) return;
    if (state.quickViewCloseTimer) {
      window.clearTimeout(state.quickViewCloseTimer);
      state.quickViewCloseTimer = null;
    }
    state.quickViewProduct = product;
    state.quickViewLastFocus = trigger || document.activeElement;
    renderUpsellDetails(product);
    upsellDetails.hidden = false;
    upsellDetails.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(function () {
      upsellDetails.classList.add('is-open');
    });
    publishUpsellEvent('mma_cart_upsell_details_opened', product, selectedUpsellVariant(product), {
      detail_source: 'quick_details'
    });
    window.setTimeout(function () {
      upsellDetailsSheet.focus();
    }, 30);
  }

  function closeUpsellDetails(reason, restoreFocus) {
    if (!upsellDetails || upsellDetails.hidden) return;
    var product = state.quickViewProduct;
    var focusTarget = state.quickViewLastFocus;
    if (product) {
      publishUpsellEvent('mma_cart_upsell_details_closed', product, selectedUpsellVariant(product), {
        detail_source: 'quick_details',
        dismiss_reason: text(reason || 'close_button')
      });
    }
    upsellDetails.classList.remove('is-open');
    upsellDetails.setAttribute('aria-hidden', 'true');
    state.quickViewProduct = null;
    state.quickViewLastFocus = null;
    state.quickViewCloseTimer = window.setTimeout(function () {
      upsellDetails.hidden = true;
      if (upsellDetailsContent) upsellDetailsContent.innerHTML = '';
      state.quickViewCloseTimer = null;
    }, 180);
    if (restoreFocus !== false && focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function isProtection(item) {
    var variantId = Number(item.variant_id || item.id);
    var handle = text(item.handle).toLowerCase();
    var title = searchable(item);
    return protectionVariantIds[String(variantId)] ||
      variantId === Number(config.protectionVariantId) ||
      handle === config.protectionHandle ||
      title.indexOf('shipping insurance') !== -1 ||
      title.indexOf('shipping protection') !== -1 ||
      title.indexOf('simpinsur') !== -1;
  }

  function isGloveGift(item) {
    var variantId = Number(item.variant_id || item.id);
    var handle = text(item.handle).toLowerCase();
    return Boolean(gloveGiftVariantId && variantId === gloveGiftVariantId) ||
      Boolean(gloveGiftHandle && handle === gloveGiftHandle);
  }

  function isAutoGloveGift(item) {
    var properties = item && item.properties ? item.properties : {};
    return isGloveGift(item) && properties._mma_gwp === 'glove_deodorizer';
  }

  function rewardGiftByTier(tier) {
    return config.rewardGifts.find(function (gift) {
      return Number(gift.tier) === Number(tier);
    });
  }

  function rewardGiftForItem(item) {
    var properties = item && item.properties ? item.properties : {};
    var propertyTier = Number(properties._mma_reward_tier || 0);
    if (propertyTier) return rewardGiftByTier(propertyTier);
    return null;
  }

  function isRewardGift(item) {
    var properties = item && item.properties ? item.properties : {};
    return properties._mma_reward_type === 'threshold_gift' && Boolean(rewardGiftForItem(item));
  }

  function rewardGiftTier(item) {
    var gift = rewardGiftForItem(item);
    return gift ? Number(gift.tier) : 0;
  }

  function rewardGiftItems(cart) {
    return visibleItems(cart).filter(isRewardGift);
  }

  function claimedRewardTiers(cart) {
    var claimed = {};
    rewardGiftItems(cart).forEach(function (item) {
      var tier = rewardGiftTier(item);
      if (tier) claimed[String(tier)] = item;
    });
    return claimed;
  }

  function visibleItems(cart) {
    return (cart && cart.items ? cart.items : []).filter(function (item) {
      return !isProtection(item);
    });
  }

  function displayItems(cart) {
    return visibleItems(cart).map(function (item, index) {
      return { item: item, index: index };
    }).sort(function (left, right) {
      var leftRewardTier = rewardGiftTier(left.item);
      var rightRewardTier = rewardGiftTier(right.item);
      var leftGift = Boolean(leftRewardTier || isGloveGift(left.item));
      var rightGift = Boolean(rightRewardTier || isGloveGift(right.item));
      if (leftGift !== rightGift) return leftGift ? -1 : 1;
      if (leftRewardTier && rightRewardTier && leftRewardTier !== rightRewardTier) {
        return leftRewardTier - rightRewardTier;
      }
      if (leftRewardTier !== rightRewardTier) return leftRewardTier ? -1 : 1;
      return left.index - right.index;
    }).map(function (entry) {
      return entry.item;
    });
  }

  function rewardGiftState(cart) {
    var claimed = claimedRewardTiers(cart);
    return {
      claimed: claimed
    };
  }

  function rewardGiftIsSatisfied(rewardState, gift) {
    if (!gift || !rewardState) return false;
    var tier = String(gift.tier);
    return Boolean(rewardState.claimed[tier]);
  }

  function nextUnsatisfiedRewardGift(rewardState, subtotal) {
    return config.rewardGifts.find(function (gift) {
      return !rewardGiftIsSatisfied(rewardState, gift) && subtotal < gift.threshold;
    });
  }

  function claimableRewardGifts(cart, rewardState, subtotal) {
    var activeState = rewardState || rewardGiftState(cart);
    var activeSubtotal = subtotal == null ? visibleSubtotal(cart) : Number(subtotal);
    return config.rewardGifts.filter(function (gift) {
      return activeSubtotal >= gift.threshold && !rewardGiftIsSatisfied(activeState, gift);
    });
  }

  function publicPropertiesSignature(item) {
    var properties = item && item.properties ? item.properties : {};
    return Object.keys(properties).filter(function (key) {
      return key && key.charAt(0) !== '_' && properties[key] != null && properties[key] !== '';
    }).sort().map(function (key) {
      return key + ':' + text(properties[key]);
    }).join('|');
  }

  function duplicateLineKey(item) {
    if (!item || isProtection(item) || isGloveGift(item) || isRewardGift(item)) return '';
    return [
      Number(item.variant_id || item.id || 0),
      text(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id),
      publicPropertiesSignature(item)
    ].join('::');
  }

  function normalizeDuplicateVisibleLines(cart) {
    var groups = {};
    visibleItems(cart).forEach(function (item) {
      var key = duplicateLineKey(item);
      if (!key || key.indexOf('0::') === 0) return;
      groups[key] = groups[key] || [];
      groups[key].push(item);
    });

    var queue = Promise.resolve(cart);
    var needsNormalization = false;
    Object.keys(groups).forEach(function (key) {
      var group = groups[key];
      if (!group || group.length < 2) return;
      needsNormalization = true;
      var keeper = group[0];
      var totalQuantity = group.reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      queue = queue.then(function () {
        return changeLineRaw(keeper.key, totalQuantity);
      });
      group.slice(1).forEach(function (duplicate) {
        queue = queue.then(function () {
          return changeLineRaw(duplicate.key, 0);
        });
      });
    });

    if (!needsNormalization) return Promise.resolve(cart);
    return queue.then(function () {
      return cartFetch('/cart.js');
    });
  }

  function protectionItem(cart) {
    return (cart && cart.items ? cart.items : []).find(isProtection);
  }

  function visibleSubtotal(cart) {
    return visibleItems(cart).reduce(function (sum, item) {
      if (isRewardGift(item)) return sum;
      return sum + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function browserStorageValue(storage, key) {
    try {
      return text(storage && storage.getItem(key) || '').trim();
    } catch (error) {
      return '';
    }
  }

  function blackjackClaimIsCurrent(cart) {
    var attributes = cart && cart.attributes ? cart.attributes : {};
    var expiresAt = text(
      attributes.mma_blackjack_order_expires_at
      || browserStorageValue(window.sessionStorage, 'mma_blackjack_order_expires_at')
    ).trim();
    if (expiresAt) {
      var expiresTime = new Date(expiresAt).getTime();
      return Number.isFinite(expiresTime) && expiresTime > Date.now();
    }

    var claimedAt = Number(browserStorageValue(window.localStorage, 'mma_blackjack_claimed_at') || 0);
    if (!claimedAt) return false;
    return Date.now() - claimedAt < config.blackjackOrderCodeHours * 60 * 60 * 1000;
  }

  function claimedBlackjackCode(cart) {
    if (!blackjackClaimIsCurrent(cart)) return '';
    var attributes = cart && cart.attributes ? cart.attributes : {};
    var code = text(
      attributes.mma_blackjack_order_code
      || browserStorageValue(window.sessionStorage, 'mma_blackjack_order_code')
    ).trim().toUpperCase();
    return /^BJ15-[A-Z0-9_-]+$/.test(code) ? code : '';
  }

  function renderClaimedBlackjackOffer(cart) {
    if (!blackjackOfferNode || !blackjackOfferCopy) return;
    var code = claimedBlackjackCode(cart);
    var subtotal = visibleSubtotal(cart);
    var threshold = Number(config.blackjackOrderThreshold || 15000);
    if (!code || subtotal <= 0) {
      blackjackOfferNode.hidden = true;
      blackjackOfferNode.removeAttribute('data-state');
      blackjackOfferCopy.textContent = '';
      return;
    }

    blackjackOfferNode.hidden = false;
    if (subtotal < threshold) {
      blackjackOfferNode.setAttribute('data-state', 'progress');
      blackjackOfferCopy.innerHTML = '<strong>Claimed.</strong> Add <strong>' + money(threshold - subtotal) + '</strong> more to unlock it.';
      return;
    }

    if (rewardCodeIsApplicable(cart, code)) {
      blackjackOfferNode.setAttribute('data-state', 'applied');
      blackjackOfferCopy.innerHTML = '<strong>Unlocked.</strong> Applied to your cart.';
      return;
    }

    blackjackOfferNode.setAttribute('data-state', 'unlocked');
    blackjackOfferCopy.innerHTML = rewardGiftItems(cart).length
      ? '<strong>Unlocked.</strong> We\'ll compare it with your cart gifts at checkout.'
      : '<strong>Unlocked.</strong> We\'ll apply it at checkout.';
  }

  function syncClaimedBlackjackDiscount(cart) {
    var code = claimedBlackjackCode(cart);
    if (
      !code
      || visibleSubtotal(cart) < Number(config.blackjackOrderThreshold || 15000)
      || rewardGiftItems(cart).length
      || rewardCodeIsApplicable(cart, code)
    ) {
      return Promise.resolve(cart);
    }
    return applyDiscountCodeSet(mergeDiscountCodes(existingDiscountCodesForCart(cart), [code])).catch(function (error) {
      console.warn('MMA Blackjack discount could not be refreshed.', error);
      return cart;
    });
  }

  function protectionTargetPrice(cart) {
    var subtotal = visibleSubtotal(cart);
    var defaultFee = Number(config.protectionDefaultFee || config.protectionPrice || 100);
    var percentage = Number(config.protectionPercentage || 4);
    var step = Number(config.protectionStep || 50);
    var rawFee = Math.max(defaultFee, subtotal * percentage / 100);
    if (!step || step <= 0) return Math.round(rawFee);
    return defaultFee + Math.round(Math.max(0, rawFee - defaultFee) / step) * step;
  }

  function protectionVariantForCart(cart) {
    var variants = config.protectionVariants || [];
    var targetPrice = protectionTargetPrice(cart);
    if (!variants.length) {
      return {
        id: Number(config.protectionVariantId),
        price: Number(config.protectionPrice || targetPrice)
      };
    }
    return variants.reduce(function (best, variant) {
      var bestDelta = Math.abs(Number(best.price) - targetPrice);
      var variantDelta = Math.abs(Number(variant.price) - targetPrice);
      if (variantDelta < bestDelta) return variant;
      if (variantDelta === bestDelta && Number(variant.price) > Number(best.price)) return variant;
      return best;
    }, variants[0]);
  }

  function updateProtectionPrice(cart) {
    if (!protectionPriceNode) return;
    var variant = protectionVariantForCart(cart);
    protectionPriceNode.textContent = '+' + money(variant.price);
  }

  function visibleQuantity(cart) {
    return visibleItems(cart).reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
  }

  function gloveGiftItem(cart) {
    return visibleItems(cart).find(isGloveGift);
  }

  function autoGloveGiftItem(cart) {
    return visibleItems(cart).find(isAutoGloveGift);
  }

  function hasEligibleGlove(cart) {
    return visibleItems(cart).some(function (item) {
      if (isGloveGift(item)) return false;
      var productType = text(item.product_type).toLowerCase();
      var haystack = searchable(item);
      return productType.indexOf('glove') !== -1 ||
        (haystack.indexOf('glove') !== -1 && haystack.indexOf('deodor') === -1);
    });
  }

  function trackGloveGift(eventName, detail) {
    var payload = Object.assign({
      event: eventName,
      source: 'cart_drawer',
      campaign: text(config.gloveGift.campaign || 'glove_deodorizer_gwp'),
      gift_handle: gloveGiftHandle,
      gift_variant_id: String(gloveGiftVariantId || ''),
      tracking_version: 'glove_gwp_2026_05_14'
    }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
  }

  function changeLineRaw(key, quantity) {
    return cartFetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  function addGloveGiftRaw() {
    return cartFetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: gloveGiftVariantId,
        quantity: 1,
        properties: {
          _mma_gwp: 'glove_deodorizer',
          _mma_source: 'glove_pdp_offer',
          _mma_campaign: text(config.gloveGift.campaign || 'glove_deodorizer_gwp'),
          _mma_tracking_version: 'glove_gwp_2026_05_14'
        }
      })
    }).then(function () {
      trackGloveGift('mma_glove_gwp_auto_added');
      return cartFetch('/cart.js');
    });
  }

  function syncGloveGift(cart) {
    if (!config.gloveGift.enabled || !gloveGiftVariantId) return Promise.resolve(cart);
    var eligible = hasEligibleGlove(cart);
    var gift = gloveGiftItem(cart);
    var autoGift = autoGloveGiftItem(cart);

    if (gift && !autoGift) {
      return changeLineRaw(gift.key, 0).then(function (updatedCart) {
        trackGloveGift('mma_glove_gwp_invalid_line_removed');
        return eligible ? syncGloveGift(updatedCart) : updatedCart;
      });
    }

    if (!eligible && gift) {
      return changeLineRaw(gift.key, 0).then(function (updatedCart) {
        trackGloveGift('mma_glove_gwp_auto_removed');
        return updatedCart;
      });
    }

    if (eligible && !gift) {
      return addGloveGiftRaw();
    }

    if (eligible && gift && Number(gift.quantity || 0) !== 1) {
      return changeLineRaw(gift.key, 1).then(function (updatedCart) {
        trackGloveGift('mma_glove_gwp_quantity_corrected');
        return updatedCart;
      });
    }

    return Promise.resolve(cart);
  }

  function rewardCodesForCart(cart) {
    var seen = {};
    rewardGiftItems(cart).forEach(function (item) {
      var gift = rewardGiftForItem(item);
      if (gift && gift.code) seen[gift.code] = true;
    });
    return Object.keys(seen);
  }

  function normalizeDiscountCode(value) {
    var code = text(value).trim().toUpperCase();
    if (!code || rewardDiscountCodes[code]) return '';
    if (!/^[A-Z0-9][A-Z0-9_-]{0,63}$/.test(code)) return '';
    return code;
  }

  function collectDiscountCode(target, value) {
    var code = normalizeDiscountCode(value);
    if (code) target[code] = true;
  }

  function collectDiscountCodeApplication(target, application) {
    if (!application) return;
    collectDiscountCode(target, application.code);
    var type = text(application.type || application.discount_application_type || '').toLowerCase();
    if (type.indexOf('discount_code') !== -1 || application.code) {
      collectDiscountCode(target, application.title);
    }
  }

  function existingDiscountCodesForCart(cart) {
    var seen = {};
    discountCodeEntries(cart).forEach(function (entry) {
      if (entry.applicable === false) return;
      collectDiscountCode(seen, entry.code);
    });
    (cart && cart.cart_level_discount_applications ? cart.cart_level_discount_applications : []).forEach(function (application) {
      collectDiscountCodeApplication(seen, application);
    });
    (cart && cart.discount_applications ? cart.discount_applications : []).forEach(function (application) {
      collectDiscountCodeApplication(seen, application);
    });
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      (item.discounts || []).forEach(function (discount) {
        collectDiscountCodeApplication(seen, discount);
      });
      (item.discount_allocations || []).forEach(function (allocation) {
        collectDiscountCodeApplication(seen, allocation.discount_application || allocation.discountApplication || allocation.application);
      });
    });
    return Object.keys(seen);
  }

  function discountCodeEntries(cart) {
    return (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).map(function (entry) {
      if (typeof entry === 'string') {
        return { code: text(entry).trim().toUpperCase(), applicable: true };
      }
      return {
        code: text(entry && entry.code || '').trim().toUpperCase(),
        applicable: !(entry && entry.applicable === false)
      };
    }).filter(function (entry) {
      return Boolean(entry.code);
    });
  }

  function discountApplicationMatches(application, code) {
    if (!application) return false;
    var normalized = text(code).trim().toUpperCase();
    return [application.code, application.title].some(function (value) {
      return text(value).trim().toUpperCase() === normalized;
    });
  }

  function cartHasDiscountApplication(cart, code) {
    var applications = [];
    applications = applications.concat(cart && cart.cart_level_discount_applications || []);
    applications = applications.concat(cart && cart.discount_applications || []);
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      (item.discounts || []).forEach(function (discount) {
        applications.push(discount);
      });
      (item.discount_allocations || []).forEach(function (allocation) {
        applications.push(allocation.discount_application || allocation.discountApplication || allocation.application || {});
      });
    });
    return applications.some(function (application) {
      return discountApplicationMatches(application, code);
    });
  }

  function rewardCodeIsApplicable(cart, code) {
    var entries = discountCodeEntries(cart);
    var normalized = text(code).trim().toUpperCase();
    if (entries.length || (cart && Array.isArray(cart.discount_codes))) {
      var entry = entries.find(function (candidate) {
        return candidate.code === normalized;
      });
      return Boolean(entry && entry.applicable);
    }
    return cartHasDiscountApplication(cart, normalized);
  }

  function missingRewardCodes(cart) {
    return rewardCodesForCart(cart).filter(function (code) {
      return !rewardCodeIsApplicable(cart, code);
    });
  }

  function missingDiscountCodes(cart, codes) {
    var applied = {};
    existingDiscountCodesForCart(cart).forEach(function (code) {
      applied[text(code).trim().toUpperCase()] = true;
    });
    return (codes || []).filter(function (code) {
      return !applied[text(code).trim().toUpperCase()];
    });
  }

  function discountCodeRequiresRewardChoice(code) {
    var normalized = text(code).trim().toUpperCase();
    return normalized.indexOf('15O') === 0
      || normalized.indexOf('10O') === 0
      || normalized.indexOf('BJ15-') === 0;
  }

  var shoppingStackDiscountCodes = {
    YOK10ADS: true,
    FTX10ADS: true
  };

  function shoppingDiscountCodesForCart(cart) {
    var seen = {};
    discountCodeEntries(cart).forEach(function (entry) {
      var normalized = text(entry.code).trim().toUpperCase();
      if (shoppingStackDiscountCodes[normalized]) seen[normalized] = true;
    });
    existingDiscountCodesForCart(cart).forEach(function (code) {
      var normalized = text(code).trim().toUpperCase();
      if (shoppingStackDiscountCodes[normalized]) seen[normalized] = true;
    });
    return Object.keys(seen);
  }

  function preferredShoppingDiscountCode(cart, codes) {
    var activeCodes = existingDiscountCodesForCart(cart).filter(function (code) {
      return shoppingStackDiscountCodes[text(code).trim().toUpperCase()];
    });
    if (activeCodes.length === 1) return activeCodes[0];

    var vendors = (cart && cart.items ? cart.items : []).filter(function (item) {
      var properties = item && item.properties ? item.properties : {};
      var handle = text(item && item.handle || '').trim().toLowerCase();
      var productType = text(item && item.product_type || '').trim().toUpperCase();
      var gloveGiftHandle = text(config.gloveGift && config.gloveGift.handle || '').trim().toLowerCase();
      var protectionHandle = text(config.protectionHandle || '').trim().toLowerCase();
      return text(properties._mma_reward_type || '') !== 'threshold_gift'
        && productType !== 'INTERNAL GIFT'
        && (!gloveGiftHandle || handle !== gloveGiftHandle)
        && (!protectionHandle || handle !== protectionHandle);
    }).map(function (item) {
      return text(item && item.vendor || '').trim().toUpperCase();
    });
    var hasYokkao = vendors.some(function (vendor) { return vendor.indexOf('YOKKAO') !== -1; });
    var hasFairtex = vendors.some(function (vendor) { return vendor.indexOf('FAIRTEX') !== -1; });
    if (hasYokkao && !hasFairtex && codes.indexOf('YOK10ADS') !== -1) return 'YOK10ADS';
    if (hasFairtex && !hasYokkao && codes.indexOf('FTX10ADS') !== -1) return 'FTX10ADS';
    return activeCodes[0] || codes[0] || '';
  }

  function applicationAllocatedAmount(application) {
    if (!application) return 0;
    return Number(
      application.total_allocated_amount
      || application.totalAllocatedAmount
      || application.amount
      || 0
    );
  }

  function discountSavingsForCode(cart, code) {
    var cartApplications = [];
    cartApplications = cartApplications.concat(cart && cart.cart_level_discount_applications || []);
    cartApplications = cartApplications.concat(cart && cart.discount_applications || []);
    var directMatches = cartApplications.filter(function (application) {
      return discountApplicationMatches(application, code);
    });
    if (directMatches.length) {
      return directMatches.reduce(function (sum, application) {
        return sum + applicationAllocatedAmount(application);
      }, 0);
    }

    return (cart && cart.items ? cart.items : []).reduce(function (total, item) {
      var allocationTotal = (item.discount_allocations || []).reduce(function (sum, allocation) {
        var application = allocation.discount_application || allocation.discountApplication || allocation.application || {};
        if (!discountApplicationMatches(application, code)) return sum;
        return sum + Number(allocation.amount || applicationAllocatedAmount(allocation));
      }, 0);
      if (allocationTotal) return total + allocationTotal;
      return total + (item.discounts || []).reduce(function (sum, discount) {
        if (!discountApplicationMatches(discount, code)) return sum;
        return sum + Number(discount.amount || 0);
      }, 0);
    }, 0);
  }

  function nonRewardDiscountSavings(cart, codes) {
    return (codes || []).reduce(function (sum, code) {
      return sum + discountSavingsForCode(cart, code);
    }, 0);
  }

  function rememberedCompetingDiscountCodes(cart) {
    var seen = {};
    rewardGiftItems(cart).forEach(function (item) {
      var properties = item && item.properties ? item.properties : {};
      text(properties._mma_reward_competing_codes || '').split(',').forEach(function (code) {
        collectDiscountCode(seen, code);
      });
    });
    return Object.keys(seen);
  }

  function rememberedCompetingDiscountValue(cart) {
    return rewardGiftItems(cart).reduce(function (largest, item) {
      var properties = item && item.properties ? item.properties : {};
      return Math.max(largest, Number(properties._mma_reward_competing_value_cents || 0));
    }, 0);
  }

  function competingDiscountContextForCart(cart) {
    var activeCodes = existingDiscountCodesForCart(cart);
    if (activeCodes.length) {
      return {
        codes: activeCodes,
        value: nonRewardDiscountSavings(cart, activeCodes)
      };
    }
    return {
      codes: rememberedCompetingDiscountCodes(cart),
      value: rememberedCompetingDiscountValue(cart)
    };
  }

  function rewardGiftRetailValue(cart) {
    return rewardGiftItems(cart).reduce(function (sum, item) {
      var lineValue = Number(item.original_line_price || 0);
      if (!lineValue) lineValue = Number(item.original_price || item.price || 0) * Number(item.quantity || 1);
      return sum + lineValue;
    }, 0);
  }

  function rewardGiftNames(cart) {
    return rewardGiftItems(cart).map(function (item) {
      var gift = rewardGiftForItem(item);
      return text(gift && gift.shortTitle || itemTitle(item));
    });
  }

  function mergeDiscountCodes(existingCodes, rewardCodes) {
    var seen = {};
    var merged = [];
    existingCodes.concat(rewardCodes).forEach(function (code) {
      var normalized = text(code).trim().toUpperCase();
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      merged.push(normalized);
    });
    return merged;
  }

  function applyRewardDiscountCodes(cart, forceClear) {
    var rewardCodes = rewardCodesForCart(cart);
    if (!rewardCodes.length && !forceClear) return Promise.resolve(cart);
    var codes = mergeDiscountCodes(existingDiscountCodesForCart(cart), rewardCodes);
    return applyDiscountCodeSet(codes);
  }

  function applyDiscountCodeSet(codes) {
    return cartFetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ discount: (codes || []).join(',') })
    }).then(function () {
      return cartFetch('/cart.js');
    });
  }

  function replaceDiscountCodeSet(codes) {
    var normalizedCodes = mergeDiscountCodes([], codes || []);
    return cartFetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ discount: '' })
    }).then(function () {
      if (!normalizedCodes.length) return null;
      return cartFetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ discount: normalizedCodes.join(',') })
      });
    }).then(function () {
      return cartFetch('/cart.js');
    });
  }

  function publishShoppingStackEvent(eventName, detail) {
    var payload = Object.assign({
      event: eventName,
      source: 'cart_drawer_promo_stack_guard',
      campaign: text(config.rewardCampaign || ''),
      stack_policy: 'shopping_ladder_allowlist',
      tracking_version: 'shopping_ladder_stack_allowlist_20260820'
    }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
    document.dispatchEvent(new CustomEvent('mma:cart-promo-stack', { detail: payload }));
  }

  function normalizeShoppingDiscountCodesForCart(cart) {
    var shoppingCodes = shoppingDiscountCodesForCart(cart);
    if (shoppingCodes.length <= 1) return Promise.resolve(cart);

    var retainedCode = preferredShoppingDiscountCode(cart, shoppingCodes);
    var removedCodes = shoppingCodes.filter(function (code) { return code !== retainedCode; });
    var targetCodes = existingDiscountCodesForCart(cart).filter(function (code) {
      var normalized = text(code).trim().toUpperCase();
      return !shoppingStackDiscountCodes[normalized] || normalized === retainedCode;
    });
    targetCodes = mergeDiscountCodes(targetCodes, rewardCodesForCart(cart));

    return replaceDiscountCodeSet(targetCodes).then(function (updatedCart) {
      publishShoppingStackEvent('mma_cart_shopping_code_deduped', {
        shopping_codes_detected: shoppingCodes.join(','),
        retained_code: retainedCode,
        removed_codes: removedCodes.join(','),
        resulting_codes: mergeDiscountCodes(existingDiscountCodesForCart(updatedCart), rewardCodesForCart(updatedCart)).join(','),
        cart_subtotal: Number(visibleSubtotal(updatedCart) || 0) / 100
      });
      return updatedCart;
    }).catch(function (error) {
      publishShoppingStackEvent('mma_cart_shopping_code_dedupe_failed', {
        shopping_codes_detected: shoppingCodes.join(','),
        retained_code: retainedCode,
        removed_codes: removedCodes.join(','),
        error_message: text(error && error.message || error)
      });
      throw error;
    });
  }

  function removeRewardGiftLines(cart) {
    var gift = rewardGiftItems(cart)[0];
    if (!gift) return Promise.resolve(cart);
    return changeLineRaw(gift.key, 0).then(removeRewardGiftLines);
  }

  function clearRewardGiftCompetingDiscount(cart) {
    var gift = rewardGiftItems(cart).find(function (item) {
      var properties = item && item.properties ? item.properties : {};
      return text(properties._mma_reward_competing_codes).trim()
        || Number(properties._mma_reward_competing_value_cents || 0) > 0;
    });
    if (!gift) return Promise.resolve(cart);
    var properties = Object.assign({}, gift.properties || {}, {
      _mma_reward_competing_codes: '',
      _mma_reward_competing_value_cents: '0'
    });
    return cartFetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({
        id: gift.key,
        quantity: Number(gift.quantity || 1),
        properties: properties
      })
    }).then(clearRewardGiftCompetingDiscount);
  }

  function publishRewardConflictEvent(eventName, conflict, detail) {
    var payload = Object.assign({
      event: eventName,
      source: 'cart_drawer_reward_guard',
      campaign: text(config.rewardCampaign || ''),
      reward_codes: (conflict && conflict.rewardCodes || []).join(','),
      missing_reward_codes: (conflict && conflict.missingCodes || []).join(','),
      competing_codes: (conflict && conflict.discountCodes || []).join(','),
      reward_value: Number(conflict && conflict.rewardValue || 0) / 100,
      competing_discount_value: Number(conflict && conflict.discountValue || 0) / 100,
      checkout_with_protection: Boolean(conflict && conflict.withProtection),
      tracking_version: 'cart_reward_conflict_guard_20260819'
    }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
    document.dispatchEvent(new CustomEvent('mma:cart-reward-conflict', { detail: payload }));
  }

  function publishRewardEvent(eventName, gift, variant, detail) {
    var payload = Object.assign({
      event: eventName,
      source: 'cart_drawer_reward',
      campaign: text(config.rewardCampaign || ''),
      tier: String(gift && gift.tier || ''),
      threshold: Number(gift && gift.threshold || 0) / 100,
      discount_code: text(gift && gift.code || ''),
      gift_handle: text(gift && gift.handle || ''),
      gift_title: text(gift && gift.shortTitle || gift && gift.title || ''),
      variant_id: String(variant && variant.id || ''),
      variant_title: text(variant && variant.title || ''),
      variant_price: Number(variant && variant.price || 0) / 100,
      cart_subtotal: Number(state.cart ? visibleSubtotal(state.cart) : 0) / 100,
      tracking_version: 'cart_ladder_claim_gifts_20260706'
    }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, payload);
    }
    document.dispatchEvent(new CustomEvent('mma:cart-reward', { detail: payload }));
  }

  function syncRewardGifts(cart) {
    if (!config.rewardGifts.length) return Promise.resolve(cart);
    var subtotal = visibleSubtotal(cart);
    var grouped = {};
    rewardGiftItems(cart).forEach(function (item) {
      var tier = rewardGiftTier(item);
      if (!tier) return;
      grouped[String(tier)] = grouped[String(tier)] || [];
      grouped[String(tier)].push(item);
    });

    var queue = Promise.resolve(cart);
    var changed = false;
    config.rewardGifts.forEach(function (gift) {
      var items = grouped[String(gift.tier)] || [];
      if (!items.length) return;
      if (subtotal < gift.threshold) {
        items.forEach(function (item) {
          changed = true;
          queue = queue.then(function () {
            return changeLineRaw(item.key, 0);
          });
        });
        publishRewardEvent('mma_cart_reward_removed_ineligible', gift, null, {
          cart_subtotal: subtotal / 100,
          threshold_gap: (gift.threshold - subtotal) / 100
        });
        return;
      }
      items.forEach(function (item, index) {
        if (index === 0 && Number(item.quantity || 0) === 1) return;
        changed = true;
        queue = queue.then(function () {
          return changeLineRaw(item.key, index === 0 ? 1 : 0);
        });
      });
    });

    if (!changed) return Promise.resolve(cart);
    return queue.then(function () {
      return cartFetch('/cart.js');
    }).then(function (updatedCart) {
      return applyRewardDiscountCodes(updatedCart, true);
    }).catch(function (error) {
      console.warn('MMA cart reward gift sync failed.', error);
      return cartFetch('/cart.js');
    });
  }

  function setBusy(value) {
    root.classList.toggle('is-busy', Boolean(value));
  }

  function shippingExclusionTooltip() {
    return '<span class="mma-cart__reward-note" data-mma-shipping-exclusion-tooltip>' +
      '<button type="button" class="mma-cart__reward-info" aria-label="Free shipping exclusions" aria-expanded="false">i</button>' +
      '<span class="mma-cart__reward-tooltip" role="tooltip">Bulky/oversized gear is excluded from free shipping. Exact rates show at checkout.</span>' +
      '</span>';
  }

  function closeShippingExclusionTooltips(scope) {
    (scope || document).querySelectorAll('[data-mma-shipping-exclusion-tooltip].is-open').forEach(function (tooltip) {
      tooltip.classList.remove('is-open');
      var bubble = tooltip.querySelector('.mma-cart__reward-tooltip');
      if (bubble) {
        bubble.style.removeProperty('--mma-tooltip-shift');
        bubble.style.removeProperty('--mma-tooltip-y-shift');
      }
      var button = tooltip.querySelector('button');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }

  function positionShippingExclusionTooltip(tooltip) {
    var bubble = tooltip && tooltip.querySelector('.mma-cart__reward-tooltip');
    if (!bubble) return;
    bubble.style.removeProperty('--mma-tooltip-shift');
    bubble.style.removeProperty('--mma-tooltip-y-shift');
    var rect = bubble.getBoundingClientRect();
    var gutter = 12;
    var shift = 0;
    var yShift = 0;
    if (rect.left < gutter) {
      shift = gutter - rect.left;
    } else if (rect.right > window.innerWidth - gutter) {
      shift = (window.innerWidth - gutter) - rect.right;
    }
    if (rect.top < gutter) {
      yShift = gutter - rect.top;
    } else if (rect.bottom > window.innerHeight - gutter) {
      yShift = (window.innerHeight - gutter) - rect.bottom;
    }
    if (shift) bubble.style.setProperty('--mma-tooltip-shift', Math.round(shift) + 'px');
    if (yShift) bubble.style.setProperty('--mma-tooltip-y-shift', Math.round(yShift) + 'px');
  }

  function toggleShippingExclusionTooltip(button) {
    var tooltip = button.closest('[data-mma-shipping-exclusion-tooltip]');
    if (!tooltip) return;
    var shouldOpen = !tooltip.classList.contains('is-open');
    closeShippingExclusionTooltips(root);
    tooltip.classList.toggle('is-open', shouldOpen);
    button.setAttribute('aria-expanded', String(shouldOpen));
    if (shouldOpen) positionShippingExclusionTooltip(tooltip);
  }

  function openDrawer() {
    state.lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mma-cart-open');
    refreshCart();
    window.setTimeout(function () {
      if (panel) panel.focus();
    }, 30);
  }

  function closeDrawer() {
    closeUpsellDetails('drawer_closed', false);
    closeRemoveConfirm();
    closeRewardConflict(false);
    closeShippingExclusionTooltips(root);
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mma-cart-open');
    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus();
    }
  }

  function cartDelay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function cartResponseLooksTransient(status, bodyText) {
    var body = text(bodyText).toLowerCase();
    return status === 408 ||
      status === 409 ||
      status === 423 ||
      status === 425 ||
      status === 429 ||
      status >= 500 ||
      body.indexOf('verifying your connection') !== -1 ||
      body.indexOf('cloudflare') !== -1 ||
      body.indexOf('captcha') !== -1;
  }

  function cartRequestError(message, response, bodyText) {
    var error = new Error(message);
    error.status = response && response.status ? response.status : 0;
    error.bodyText = text(bodyText).slice(0, 500);
    error.transient = cartResponseLooksTransient(error.status, error.bodyText);
    return error;
  }

  function cartActionErrorCopy(error) {
    var status = Number(error && error.status || 0);
    if (status === 422) return 'That quantity is not available. Cart refreshed.';
    if (error && error.transient) return 'Cart is taking a moment. Retrying now.';
    return 'Cart update did not finish. Cart refreshed.';
  }

  function resetRefreshRetry() {
    state.refreshRetryCount = 0;
    if (state.refreshRetryTimer) {
      window.clearTimeout(state.refreshRetryTimer);
      state.refreshRetryTimer = null;
    }
  }

  function scheduleRefreshRetry() {
    if (state.refreshRetryTimer || state.refreshRetryCount >= 3) return;
    state.refreshRetryCount += 1;
    state.refreshRetryTimer = window.setTimeout(function () {
      state.refreshRetryTimer = null;
      refreshCart();
    }, 700 * state.refreshRetryCount);
  }

  function recoverCartPipelineStep(label, cart, error) {
    console.warn(label, error);
    return cartFetch('/cart.js').catch(function () {
      return cart;
    });
  }

  function cartFetch(path, options) {
    var requestOptions = Object.assign({
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    }, options || {});
    var maxAttempts = Number(requestOptions.maxAttempts || 3);
    var attempt = Number(requestOptions.attempt || 1);
    delete requestOptions.maxAttempts;
    delete requestOptions.attempt;

    return fetch(path, requestOptions).then(function (response) {
      return response.text().then(function (bodyText) {
        var contentType = response.headers && response.headers.get ? text(response.headers.get('content-type')).toLowerCase() : '';
        var jsonLike = /^\s*[\[{]/.test(bodyText || '');
        if (!response.ok) {
          throw cartRequestError('Cart request failed (' + path + '): ' + response.status, response, bodyText);
        }
        if (bodyText && contentType.indexOf('application/json') === -1 && !jsonLike) {
          throw cartRequestError('Cart request returned non-JSON (' + path + ').', response, bodyText);
        }
        try {
          return bodyText ? JSON.parse(bodyText) : {};
        } catch (error) {
          throw cartRequestError('Cart JSON could not be parsed (' + path + ').', response, bodyText);
        }
      });
    }).catch(function (error) {
      if (error && error.transient && attempt < maxAttempts) {
        return cartDelay(260 * attempt).then(function () {
          return cartFetch(path, Object.assign({}, options || {}, {
            attempt: attempt + 1,
            maxAttempts: maxAttempts
          }));
        });
      }
      throw error;
    });
  }

  function productJsonUrl(handle) {
    return '/products/' + encodeURIComponent(handle) + '.js';
  }

  function imageUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value.src || '';
  }

  function normalizeUpsellProduct(product) {
    if (!product || product.available === false) return null;
    var productImage = imageUrl(product.featured_image || product.image);
    var productDetails = (config.upsellDetails || {})[text(product.handle)] || {};
    var variants = (product.variants || []).filter(function (variant) {
      return variant && variant.available !== false;
    }).map(function (variant) {
      return {
        id: variant.id,
        title: variant.title,
        price: Number(variant.price || 0),
        compareAtPrice: Number(variant.compare_at_price || 0),
        available: variant.available !== false,
        image: imageUrl(variant.featured_image) || productImage
      };
    });
    if (!variants.length) return null;
    return {
      id: product.id,
      handle: product.handle,
      title: product.title,
      vendor: product.vendor,
      productType: product.type,
      url: product.url || ('/products/' + product.handle),
      image: productImage,
      variantId: variants[0].id,
      variantTitle: variants[0].title,
      price: variants[0].price,
      compareAtPrice: variants[0].compareAtPrice,
      available: true,
      details: productDetails,
      variants: variants
    };
  }

  function loadUpsellProducts() {
    if (state.upsellsLoaded) return Promise.resolve(config.upsells || []);
    if (state.upsellsLoading) return state.upsellsLoading;
    var giftUpsellHandle = gloveGiftHandle || 'yokkao-gloves-deodorizer';
    var handles = (config.upsellHandles || []).filter(function (handle) {
      var normalized = text(handle).toLowerCase();
      return normalized !== giftUpsellHandle && !rewardGiftHandles[normalized];
    });
    if (!handles.length) {
      state.upsellsLoaded = true;
      config.upsells = config.upsells || [];
      return Promise.resolve(config.upsells);
    }
    state.upsellsLoading = Promise.all(handles.map(function (handle) {
      return fetch(productJsonUrl(handle), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Upsell product request failed: ' + response.status);
        return response.json();
      }).then(normalizeUpsellProduct).catch(function (error) {
        console.warn('MMA cart upsell product could not be loaded for ' + handle + '.', error);
        return null;
      });
    })).then(function (products) {
      config.upsells = products.filter(Boolean);
      state.upsellsLoaded = true;
      return config.upsells;
    }).finally(function () {
      state.upsellsLoading = null;
    });
    return state.upsellsLoading;
  }

  function loadSalePricingForCart(cart) {
    var handles = [];
    visibleItems(cart).forEach(function (item) {
      var handle = text(item.handle);
      if (!handle || state.salePricingHandles[handle]) return;
      state.salePricingHandles[handle] = 'loading';
      handles.push(handle);
    });
    if (!handles.length) return;

    Promise.all(handles.map(function (handle) {
      return fetch(productJsonUrl(handle), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product request failed: ' + response.status);
        return response.json();
      }).then(function (product) {
        (product.variants || []).forEach(function (variant) {
          state.variantSalePricing[String(variant.id)] = {
            price: Number(variant.price || 0),
            compareAtPrice: Number(variant.compare_at_price || 0)
          };
        });
        state.salePricingHandles[handle] = 'loaded';
        return true;
      }).catch(function (error) {
        state.salePricingHandles[handle] = 'failed';
        console.warn('MMA cart sale pricing could not be loaded for ' + handle + '.', error);
        return false;
      });
    })).then(function (results) {
      if (results.some(Boolean) && state.cart) render(state.cart);
    });
  }

  function openRemoveConfirm(item) {
    if (!removeConfirm || !removeConfirmDialog) return;
    state.pendingRemove = item;
    if (removeConfirmCopy) {
      removeConfirmCopy.innerHTML = 'You are about to remove <strong>' + html(itemTitle(item)) + '</strong>. This may change your subtotal and reward progress.';
    }
    removeConfirm.hidden = false;
    root.classList.add('has-confirm');
    window.setTimeout(function () {
      removeConfirmDialog.focus();
    }, 20);
  }

  function closeRemoveConfirm() {
    if (!removeConfirm) return;
    state.pendingRemove = null;
    removeConfirm.hidden = true;
    root.classList.remove('has-confirm');
    if (panel && root.classList.contains('is-open')) panel.focus();
  }

  function confirmRemove() {
    var item = state.pendingRemove;
    if (!item) {
      closeRemoveConfirm();
      return;
    }
    closeRemoveConfirm();
    changeLine(item.key, 0);
  }

  function refreshCart() {
    if (loading) loading.hidden = false;
    return cartFetch('/cart.js')
      .then(function (cart) {
        return syncGloveGift(cart).catch(function (error) {
          return recoverCartPipelineStep('MMA cart glove gift sync failed during refresh.', cart, error);
        });
      })
      .then(function (cart) {
        return syncRewardGifts(cart).catch(function (error) {
          return recoverCartPipelineStep('MMA cart reward gift sync failed during refresh.', cart, error);
        });
      })
      .then(function (cart) {
        return normalizeDuplicateVisibleLines(cart).catch(function (error) {
          return recoverCartPipelineStep('MMA cart duplicate normalization failed during refresh.', cart, error);
        });
      })
      .then(syncClaimedBlackjackDiscount)
      .then(function (cart) {
        resetRefreshRetry();
        state.cart = cart;
        render(cart);
        return cart;
      })
      .catch(function (error) {
        console.warn('MMA cart refresh failed.', error);
        if (error && error.transient) {
          scheduleRefreshRetry();
        } else {
          resetRefreshRetry();
        }
        if (state.cart) {
          render(state.cart);
        } else {
          if (itemsNode) itemsNode.innerHTML = '';
          if (emptyNode) emptyNode.hidden = true;
          if (footerNode) footerNode.hidden = true;
          if (rewardGiftSection) {
            rewardGiftSection.hidden = true;
            rewardGiftSection.innerHTML = '';
          }
          if (upsellSection) upsellSection.hidden = true;
          if (countLabel) countLabel.textContent = 'Loading cart';
        }
        if (rewardCopy) rewardCopy.textContent = error && error.transient ? 'Cart is taking a moment. Retrying now.' : 'Cart update did not finish. Current cart shown.';
        if (progressFill && !state.cart) progressFill.style.transform = 'scaleX(0)';
        return state.cart;
      })
      .finally(function () {
        if (loading) loading.hidden = true;
      });
  }

  function updateCartBlip(cart) {
    var quantity = visibleQuantity(cart);
    var label = quantity === 1 ? 'View cart, 1 item' : 'View cart, ' + quantity + ' items';
    document.querySelectorAll('.cart-blip').forEach(function (node) {
      var cartLink = node.closest('.header-item__link');
      node.textContent = String(quantity);
      if (cartLink) {
        cartLink.setAttribute('aria-label', label);
        cartLink.querySelectorAll('[data-mma-cart-count-label]').forEach(function (labelNode) {
          labelNode.textContent = label;
        });
      }
      if (quantity > 0) {
        node.hidden = false;
        if (cartLink) {
          cartLink.classList.add('has-blip-visible');
          cartLink.classList.remove('is-cart-updated');
          window.requestAnimationFrame(function () {
            cartLink.classList.add('is-cart-updated');
            window.setTimeout(function () {
              cartLink.classList.remove('is-cart-updated');
            }, 650);
          });
        }
      } else {
        node.hidden = true;
        if (cartLink) cartLink.classList.remove('has-blip-visible', 'is-cart-updated');
      }
    });
  }

  function render(cart) {
    var quantity = visibleQuantity(cart);
    var subtotal = visibleSubtotal(cart);
    var hasItems = quantity > 0;
    if (countLabel) countLabel.textContent = quantity + (quantity === 1 ? ' item' : ' items');
    if (subtotalNode) subtotalNode.textContent = money(subtotal);
    renderClaimedBlackjackOffer(cart);
    updateProtectionPrice(cart);
    if (itemsNode) itemsNode.innerHTML = displayItems(cart).map(renderItem).join('');
    if (emptyNode) emptyNode.hidden = hasItems;
    if (footerNode) footerNode.hidden = !hasItems;
    renderRewards(cart);
    renderRewardGifts(cart);
    renderUpsells(cart);
    updateCartBlip(cart);
    loadSalePricingForCart(cart);
  }

  function itemOriginalLinePrice(item) {
    var paidLine = Number(item.final_line_price || item.line_price || 0);
    var originalLine = Number(item.original_line_price || item.line_price || paidLine);
    var pricing = state.variantSalePricing[String(item.variant_id || item.id)] || {};
    var compareAtPrice = Number(pricing.compareAtPrice || 0);
    var salePrice = Number(pricing.price || item.final_price || item.price || 0);
    var compareAtLine = compareAtPrice > salePrice ? compareAtPrice * Number(item.quantity || 1) : 0;
    return Math.max(originalLine, compareAtLine, paidLine);
  }

  function itemSavings(item) {
    var paidLine = Number(item.final_line_price || item.line_price || 0);
    return Math.max(0, itemOriginalLinePrice(item) - paidLine);
  }

  function renderRewards(cart) {
    var subtotal = visibleSubtotal(cart);
    var rewardState = rewardGiftState(cart);
    var wrapsGift = rewardGiftByTier(Number(config.wrapsGiftThreshold || 22000) / 100) || rewardGiftByTier(220);
    var mouthGuardGift = rewardGiftByTier(Number(config.mouthGuardGiftThreshold || 27000) / 100) || rewardGiftByTier(270);
    var wrapsSatisfied = rewardGiftIsSatisfied(rewardState, wrapsGift);
    var mouthGuardSatisfied = rewardGiftIsSatisfied(rewardState, mouthGuardGift);
    var claimableGifts = claimableRewardGifts(cart, rewardState, subtotal);
    var nextClaimableGift = claimableGifts[0];
    var thresholds = [
      { amount: Number(config.freeShippingThreshold || 17000), label: 'FREE Shipping' },
      { amount: Number(config.wrapsGiftThreshold || 22000), label: 'Free Wraps', gift: wrapsGift },
      { amount: Number(config.mouthGuardGiftThreshold || 27000), label: 'Free Mouth Guard', gift: mouthGuardGift }
    ];
    var next = thresholds.find(function (tier) {
      if (tier.gift && rewardGiftIsSatisfied(rewardState, tier.gift) && subtotal >= thresholds[0].amount) return false;
      return subtotal < tier.amount;
    });
    var stops = [50, 75, 100];
    var progress = 100;
    for (var index = 0; index < thresholds.length; index += 1) {
      var previousAmount = index === 0 ? 0 : thresholds[index - 1].amount;
      var currentAmount = thresholds[index].amount;
      var previousStop = index === 0 ? 0 : stops[index - 1];
      var currentStop = stops[index];
      if (subtotal < currentAmount) {
        progress = previousStop + (Math.max(0, subtotal - previousAmount) / (currentAmount - previousAmount)) * (currentStop - previousStop);
        break;
      }
    }
    progress = Math.max(0, Math.min(100, progress));
    if (subtotal >= thresholds[0].amount && wrapsSatisfied) progress = Math.max(progress, stops[1]);
    if (subtotal >= thresholds[0].amount && mouthGuardSatisfied) progress = Math.max(progress, stops[2]);
    if (progressFill) progressFill.style.transform = 'scaleX(' + (progress / 100) + ')';
    root.querySelectorAll('[data-mma-tier]').forEach(function (node) {
      var tierIndex = Number(node.getAttribute('data-mma-tier'));
      var tier = thresholds[tierIndex];
      if (!tier) return;
      var covered = Boolean(tier.gift && rewardGiftIsSatisfied(rewardState, tier.gift) && subtotal >= thresholds[0].amount);
      node.classList.toggle('is-earned', subtotal >= tier.amount || covered);
      node.classList.toggle('is-next', next && tier.amount === next.amount);
    });
    if (!rewardCopy) return;
    if (!next) {
      if (nextClaimableGift && nextClaimableGift === wrapsGift && claimableGifts.length > 1) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Free wraps unlocked.</strong> Claim them below. Mouth guard is ready next. ' + shippingExclusionTooltip();
      } else if (nextClaimableGift === wrapsGift) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Free wraps unlocked.</strong> Claim them below before checkout. ' + shippingExclusionTooltip();
      } else if (nextClaimableGift === mouthGuardGift) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Mouth guard unlocked.</strong> Claim it below before checkout. ' + shippingExclusionTooltip();
      } else if (wrapsSatisfied && mouthGuardSatisfied) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Cart rewards covered.</strong> You\'re set for checkout. ' + shippingExclusionTooltip();
      } else if (wrapsSatisfied && !mouthGuardSatisfied) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Mouth guard unlocked.</strong> Claim it below before checkout. ' + shippingExclusionTooltip();
      } else if (!wrapsSatisfied && mouthGuardSatisfied) {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Free wraps unlocked.</strong> Claim them below before checkout. ' + shippingExclusionTooltip();
      } else {
        rewardCopy.innerHTML = '<strong class="mma-cart__reward-final">Full cart rewards unlocked.</strong> Claim your wraps and mouth guard below before checkout. ' + shippingExclusionTooltip();
      }
    } else if (next.amount === thresholds[0].amount) {
      rewardCopy.innerHTML = 'Add <strong class="mma-cart__reward-highlight">' + money(next.amount - subtotal) + '</strong> and get <strong class="mma-cart__reward-highlight">FREE Shipping</strong>.';
    } else if (next.amount === thresholds[1].amount) {
      rewardCopy.innerHTML = '<strong>Free shipping locked in.</strong> ' + shippingExclusionTooltip() + ' You\'re <strong class="mma-cart__reward-highlight">' + money(next.amount - subtotal) + '</strong> from a free pair of premium hand wraps.';
    } else {
      if (wrapsSatisfied) {
        rewardCopy.innerHTML = '<strong>Wraps covered.</strong> Add <strong class="mma-cart__reward-highlight">' + money(next.amount - subtotal) + '</strong> more for a free YOKKAO mouth guard. ' + shippingExclusionTooltip();
      } else {
        rewardCopy.innerHTML = '<strong>Free wraps unlocked.</strong> Claim them below, or add <strong class="mma-cart__reward-highlight">' + money(next.amount - subtotal) + '</strong> more for a free YOKKAO mouth guard. ' + shippingExclusionTooltip();
      }
    }
  }

  function selectedRewardVariant(gift) {
    var select = rewardGiftSection ? rewardGiftSection.querySelector('[data-mma-reward-tier="' + gift.tier + '"] [data-mma-reward-variant]') : null;
    var selectedId = select ? Number(select.value) : Number((gift.variants[0] || {}).id);
    return gift.variants.find(function (variant) {
      return Number(variant.id) === selectedId;
    }) || gift.variants[0];
  }

  function renderRewardVariantSelect(gift, selectedVariant) {
    if (!gift.variants.length || gift.variants.length === 1) return '';
    var selectorId = 'mma-cart-reward-' + gift.tier;
    return [
      '<label class="mma-cart__reward-gift-variant-label" for="' + html(selectorId) + '">Option</label>',
      '<select id="' + html(selectorId) + '" class="mma-cart__reward-gift-select" data-mma-reward-variant>',
      gift.variants.map(function (variant) {
        return '<option value="' + html(variant.id) + '" data-price="' + html(variant.price) + '" data-image="' + html(variant.image || '') + '"' + (Number(variant.id) === Number(selectedVariant.id) ? ' selected' : '') + '>' + html(variant.title) + '</option>';
      }).join(''),
      '</select>'
    ].join('');
  }

  function renderRewardGifts(cart) {
    if (!rewardGiftSection || !config.rewardGifts.length) return;
    var subtotal = visibleSubtotal(cart);
    var hasItems = visibleQuantity(cart) > 0;
    var rewardState = rewardGiftState(cart);
    var claimableGifts = claimableRewardGifts(cart, rewardState, subtotal);
    if (!hasItems || !claimableGifts.length) {
      rewardGiftSection.hidden = true;
      rewardGiftSection.innerHTML = '';
      return;
    }
    var gift = claimableGifts[0];
    var selectedVariant = selectedRewardVariant(gift);
    if (!selectedVariant || !selectedVariant.id) {
      rewardGiftSection.hidden = true;
      rewardGiftSection.innerHTML = '';
      return;
    }
    var viewKey = gift.tier + ':' + selectedVariant.id;
    if (!state.seenRewardViews[viewKey]) {
      state.seenRewardViews[viewKey] = true;
      publishRewardEvent('mma_cart_reward_claim_viewed', gift, selectedVariant);
    }
    var image = selectedVariant.image || (gift.variants[0] && gift.variants[0].image) || '';
    rewardGiftSection.hidden = false;
    rewardGiftSection.innerHTML = [
      '<article class="mma-cart__reward-gift-card is-eligible is-claimable" data-mma-reward-tier="' + html(gift.tier) + '">',
      image ? '<img class="mma-cart__reward-gift-image" src="' + html(image) + '" alt="' + html(gift.shortTitle) + '" loading="lazy" data-mma-reward-image>' : '<span class="mma-cart__reward-gift-image" data-mma-reward-image></span>',
      '<div class="mma-cart__reward-gift-copy">',
      '<p class="mma-cart__reward-gift-title">' + html(gift.shortTitle) + '</p>',
      '<p class="mma-cart__reward-gift-status">' + html(gift.claimCopy) + '</p>',
      renderRewardVariantSelect(gift, selectedVariant),
      '</div>',
      '<button type="button" class="mma-cart__reward-gift-add" data-mma-claim-reward="' + html(gift.tier) + '">' + html(gift.buttonLabel) + '</button>',
      '</article>'
    ].join('');
  }

  function renderItem(item) {
    var title = itemTitle(item);
    var thresholdGift = isRewardGift(item);
    var gift = thresholdGift || (isGloveGift(item) && Number(item.final_line_price || item.line_price || 0) === 0);
    var autoGift = isAutoGloveGift(item);
    var meta = [item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '', item.vendor || '']
      .filter(Boolean)
      .join(' / ');
    var image = item.image || '';
    var url = item.url || '#';
    var savings = itemSavings(item);
    var originalPrice = itemOriginalLinePrice(item);
    var linePrice = Number(item.final_line_price || item.line_price || 0);
    if (thresholdGift) {
      originalPrice = itemOriginalLinePrice(item);
      savings = originalPrice;
      linePrice = 0;
    }
    return [
      '<article class="mma-cart__item' + (gift ? ' is-free-gift' : '') + '" data-mma-cart-key="' + html(item.key) + '">',
      autoGift
        ? '<span class="mma-cart__item-media" aria-hidden="true">'
        : '<a class="mma-cart__item-media" href="' + html(url) + '" aria-label="View ' + html(title) + '">',
      image ? '<img class="mma-cart__item-image" src="' + html(image) + '" alt="' + html(title) + '" loading="lazy">' : '<span class="mma-cart__item-image"></span>',
      autoGift ? '</span>' : '</a>',
      '<div>',
      autoGift
        ? '<span class="mma-cart__item-copy-link">'
        : '<a class="mma-cart__item-copy-link" href="' + html(url) + '">',
      '<span class="mma-cart__item-title">' + html(title) + '</span>',
      gift ? '<span class="mma-cart__free-gift-badge">FREE GIFT</span>' : '',
      meta ? '<span class="mma-cart__item-meta">' + html(meta) + '</span>' : '',
      autoGift ? '</span>' : '</a>',
      '<div class="mma-cart__item-bottom">',
      gift
        ? '<span class="mma-cart__gift-included" aria-label="Free gift included">Included</span>'
        : '<div class="mma-cart__quantity" aria-label="Quantity for ' + html(title) + '">' +
          '<button type="button" class="mma-cart__qty-button" data-mma-qty="-1" aria-label="Decrease quantity">-</button>' +
          '<span class="mma-cart__qty-value">' + Number(item.quantity || 0) + '</span>' +
          '<button type="button" class="mma-cart__qty-button" data-mma-qty="1" aria-label="Increase quantity">+</button>' +
          '</div>',
      '<div class="mma-cart__item-price-stack">',
      savings > 0 ? '<span class="mma-cart__item-compare-price">' + money(originalPrice) + '</span>' : '',
      '<span class="mma-cart__item-current-row">',
      savings > 0 ? '<span class="mma-cart__item-savings">Save ' + money(savings) + '</span>' : '',
      '<span class="mma-cart__item-price">' + money(linePrice) + '</span>',
      '</span>',
      '</div>',
      '</div>',
      '</div>',
      autoGift ? '' : '<button type="button" class="mma-cart__remove" data-mma-remove aria-label="Remove ' + html(title) + '">&times;</button>',
      '</article>'
    ].join('');
  }

  function rankUpsells(cart) {
    var cartHandles = visibleItems(cart).map(function (item) {
      return text(item.handle).toLowerCase();
    });
    var profile = cartProfile(cart);
    var giftUpsellHandle = gloveGiftHandle || 'yokkao-gloves-deodorizer';
    return (config.upsells || []).map(function (product, index) {
      if (!product || !product.available) return null;
      var handle = text(product.handle).toLowerCase();
      if (handle === giftUpsellHandle || rewardGiftHandles[handle] || cartHandles.indexOf(handle) !== -1) return null;
      var recommendation = recommendationScore(product, cart, profile);
      if (!recommendation || recommendation.score <= 0) return null;
      product._mmaRecommendation = Object.assign({ originalIndex: index }, recommendation);
      return product;
    }).filter(Boolean).sort(function (left, right) {
      var leftRecommendation = left._mmaRecommendation || {};
      var rightRecommendation = right._mmaRecommendation || {};
      if (Number(rightRecommendation.score || 0) !== Number(leftRecommendation.score || 0)) {
        return Number(rightRecommendation.score || 0) - Number(leftRecommendation.score || 0);
      }
      return Number(leftRecommendation.originalIndex || 0) - Number(rightRecommendation.originalIndex || 0);
    }).slice(0, 3);
  }

  function renderUpsells(cart) {
    if (!state.upsellsLoaded) {
      if (upsellSection) upsellSection.hidden = true;
      loadUpsellProducts().then(function () {
        if (state.cart) renderUpsells(state.cart);
      });
      return;
    }
    state.upsells = rankUpsells(cart);
    if (!upsellSection || !upsellCard) return;
    if (!visibleQuantity(cart) || state.upsells.length === 0) {
      closeUpsellDetails('recommendation_unavailable', false);
      upsellSection.hidden = true;
      return;
    }
    upsellSection.hidden = false;
    if (upsellHeading) {
      var subtotal = visibleSubtotal(cart);
      var rewardState = rewardGiftState(cart);
      var wrapsGift = rewardGiftByTier(Number(config.wrapsGiftThreshold || 22000) / 100) || rewardGiftByTier(220);
      var mouthGuardGift = rewardGiftByTier(Number(config.mouthGuardGiftThreshold || 27000) / 100) || rewardGiftByTier(270);
      var wrapsSatisfied = rewardGiftIsSatisfied(rewardState, wrapsGift);
      var mouthGuardSatisfied = rewardGiftIsSatisfied(rewardState, mouthGuardGift);
      var freeShippingGap = Number(config.freeShippingThreshold || 17000) - subtotal;
      var wrapsGap = Number(config.wrapsGiftThreshold || 22000) - subtotal;
      var mouthGuardGap = Number(config.mouthGuardGiftThreshold || 27000) - subtotal;
      if (!wrapsSatisfied && wrapsGap > 0 && freeShippingGap <= 0) {
        upsellHeading.textContent = 'Reach the free wraps';
      } else if (!mouthGuardSatisfied && mouthGuardGap > 0 && (wrapsSatisfied || wrapsGap <= 0)) {
        upsellHeading.textContent = 'Reach the mouth guard';
      } else if (!mouthGuardSatisfied && mouthGuardGap <= 0) {
        upsellHeading.textContent = 'Complete the kit';
      } else {
        upsellHeading.textContent = freeShippingGap > 0 && freeShippingGap <= 3000 ? 'Unlock free shipping' : 'Complete the kit';
      }
    }
    state.upsellIndex = Math.min(state.upsellIndex, state.upsells.length - 1);
    var product = state.upsells[state.upsellIndex];
    var variants = availableVariants(product);
    var recommendation = product._mmaRecommendation || {};
    var selectedVariant = variants.find(function (variant) {
      var rememberedId = state.selectedUpsellVariants[product.handle];
      return Number(variant.id) === Number(rememberedId || recommendation.variantId);
    }) || variants[0];
    state.selectedUpsellVariants[product.handle] = Number(selectedVariant.id);
    var selectorId = 'mma-upsell-variant-' + product.handle;
    var variantSelect = variants.length > 1 ? [
      '<label class="mma-cart__upsell-variant-label" for="' + html(selectorId) + '">Option</label>',
      '<select id="' + html(selectorId) + '" class="mma-cart__upsell-select" data-mma-upsell-variant>',
      variants.map(function (variant) {
        return '<option value="' + html(variant.id) + '" data-price="' + html(variant.price) + '" data-image="' + html(variant.image || product.image || '') + '"' + (Number(variant.id) === Number(selectedVariant.id) ? ' selected' : '') + '>' + html(variant.title) + '</option>';
      }).join(''),
      '</select>'
    ].join('') : '';
    var detailsButton = hasUpsellDetails(product) ? '<button type="button" class="mma-cart__upsell-details-button" data-mma-upsell-details-open="' + html(product.handle) + '" aria-label="View quick details for ' + html(product.title) + '">i</button>' : '';
    upsellCard.innerHTML = [
      '<article class="mma-cart__upsell-card" data-mma-upsell-handle="' + html(product.handle) + '" data-mma-upsell-slot="' + (state.upsellIndex + 1) + '">',
      (selectedVariant.image || product.image) ? '<img class="mma-cart__upsell-image" src="' + html(selectedVariant.image || product.image) + '" alt="' + html(product.title) + '" loading="lazy" data-mma-upsell-image>' : '<div class="mma-cart__upsell-image" data-mma-upsell-image></div>',
      '<div class="mma-cart__upsell-info">',
      '<div class="mma-cart__upsell-title-row">',
      '<p class="mma-cart__upsell-title">' + html(product.title) + '</p>',
      detailsButton,
      '</div>',
      '<p class="mma-cart__upsell-reason" data-mma-upsell-reason>' + html(recommendation.reason || recommendationReason(productRole(product), cartProfile(cart), false, 0)) + '</p>',
      '<div class="mma-cart__upsell-meta">',
      '<span class="mma-cart__upsell-price" data-mma-upsell-price>' + money(selectedVariant.price) + '</span>',
      variantSelect,
      '</div>',
      '</div>',
      '<button type="button" class="mma-cart__upsell-add" data-mma-add-upsell="' + html(product.handle) + '">Add</button>',
      '</article>'
    ].join('');
    if (upsellControls) upsellControls.hidden = state.upsells.length < 2;
    if (upsellPosition) upsellPosition.textContent = (state.upsellIndex + 1) + '/' + state.upsells.length;
    var viewKey = product.handle + ':' + selectedVariant.id + ':' + (state.upsellIndex + 1);
    if (!state.seenUpsellViews[viewKey]) {
      state.seenUpsellViews[viewKey] = true;
      publishUpsellEvent('mma_cart_upsell_viewed', product, selectedVariant, { detail_source: 'card' });
    }
  }

  function changeLine(key, quantity) {
    var wasRewardGift = state.cart && visibleItems(state.cart).some(function (cartItem) {
      return cartItem.key === key && isRewardGift(cartItem);
    });
    setBusy(true);
    return cartFetch('/cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      return syncGloveGift(cart).catch(function (error) {
        return recoverCartPipelineStep('MMA cart glove gift sync failed after quantity change.', cart, error);
      });
    }).then(function (cart) {
      return syncRewardGifts(cart).catch(function (error) {
        return recoverCartPipelineStep('MMA cart reward gift sync failed after quantity change.', cart, error);
      });
    }).then(function (cart) {
      return normalizeDuplicateVisibleLines(cart).catch(function (error) {
        return recoverCartPipelineStep('MMA cart duplicate normalization failed after quantity change.', cart, error);
      });
    }).then(function (cart) {
      return wasRewardGift ? applyRewardDiscountCodes(cart, true) : cart;
    }).then(function (cart) {
      state.cart = cart;
      render(cart);
      return cart;
    }).catch(function (error) {
      console.warn('MMA cart quantity update failed.', error);
      if (rewardCopy) rewardCopy.textContent = cartActionErrorCopy(error);
      return refreshCart();
    }).finally(function () {
      setBusy(false);
    });
  }

  function addVariant(variantId, quantity, properties) {
    setBusy(true);
    return cartFetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1,
        properties: properties || {}
      })
    }).then(refreshCart).catch(function (error) {
      console.warn('MMA cart add failed.', error);
      if (rewardCopy) rewardCopy.textContent = cartActionErrorCopy(error);
      return refreshCart();
    }).finally(function () {
      setBusy(false);
    });
  }

  function updateRewardVariantSelection(select) {
    var card = select.closest('[data-mma-reward-tier]');
    if (!card) return;
    var gift = rewardGiftByTier(card.getAttribute('data-mma-reward-tier'));
    if (!gift) return;
    var variant = selectedRewardVariant(gift);
    var imageNode = card.querySelector('[data-mma-reward-image]');
    if (imageNode && variant.image) {
      if (imageNode.tagName && imageNode.tagName.toLowerCase() === 'img') {
        imageNode.setAttribute('src', variant.image);
      }
    }
    publishRewardEvent('mma_cart_reward_variant_selected', gift, variant);
  }

  function claimRewardGift(gift) {
    if (!gift || root.classList.contains('is-busy')) return;
    var subtotal = visibleSubtotal(state.cart);
    if (subtotal < gift.threshold) {
      renderRewardGifts(state.cart);
      return;
    }
    var existing = claimedRewardTiers(state.cart)[String(gift.tier)];
    if (existing) {
      renderRewardGifts(state.cart);
      return;
    }
    var variant = selectedRewardVariant(gift);
    if (!variant || !variant.id) return;
    var competingDiscount = competingDiscountContextForCart(state.cart);
    publishRewardEvent('mma_cart_reward_claim_clicked', gift, variant);
    setBusy(true);
    return cartFetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        id: Number(variant.id),
        quantity: 1,
        properties: {
          _mma_source: 'cart_drawer_reward',
          _mma_reward_type: 'threshold_gift',
          _mma_reward_tier: String(gift.tier),
          _mma_reward_code: gift.code,
          _mma_reward_handle: gift.handle,
          _mma_reward_campaign: text(config.rewardCampaign || ''),
          _mma_reward_threshold: money(gift.threshold),
          _mma_cart_subtotal_at_claim: money(subtotal),
          _mma_reward_competing_codes: competingDiscount.codes.join(','),
          _mma_reward_competing_value_cents: String(competingDiscount.value || 0),
          _mma_tracking_version: 'cart_ladder_claim_gifts_20260706'
        }
      })
    }).then(function () {
      publishRewardEvent('mma_cart_reward_claim_added', gift, variant);
      return cartFetch('/cart.js');
    }).then(function (cart) {
      return syncRewardGifts(cart);
    }).then(function (cart) {
      return applyRewardDiscountCodes(cart);
    }).then(function (cart) {
      publishRewardEvent('mma_cart_reward_discount_applied', gift, variant);
      state.cart = cart;
      render(cart);
      return cart;
    }).catch(function (error) {
      console.warn('MMA cart reward claim failed.', error);
      publishRewardEvent('mma_cart_reward_claim_failed', gift, variant, {
        error_message: text(error && error.message || error)
      });
      if (rewardCopy) rewardCopy.textContent = cartActionErrorCopy(error);
      return refreshCart();
    }).finally(function () {
      setBusy(false);
    });
  }

  function configureRewardConflictChoice(button, labelNode, metaNode, badgeNode, action, label, meta, recommended) {
    if (!button) return;
    button.setAttribute('data-mma-reward-conflict-action', action);
    button.classList.toggle('is-recommended', Boolean(recommended));
    if (labelNode) labelNode.textContent = label;
    if (metaNode) metaNode.textContent = meta;
    if (badgeNode) badgeNode.hidden = !recommended;
  }

  function closeRewardConflict(restoreFocus) {
    if (!rewardConflict) return;
    var conflict = state.pendingRewardConflict;
    rewardConflict.hidden = true;
    root.classList.remove('has-reward-conflict');
    state.pendingRewardConflict = null;
    if (restoreFocus !== false) {
      var focusTarget = conflict && conflict.trigger;
      if (focusTarget && typeof focusTarget.focus === 'function') {
        focusTarget.focus();
      } else if (panel && root.classList.contains('is-open')) {
        panel.focus();
      }
    }
  }

  function renderRewardConflictError(conflict) {
    conflict.mode = 'validation_error';
    if (rewardConflictTitle) rewardConflictTitle.textContent = "We couldn't verify your gifts";
    if (rewardConflictCopy) {
      rewardConflictCopy.textContent = 'Checkout is paused so nothing marked free becomes a paid item. Try again, or remove the gifts and continue.';
    }
    configureRewardConflictChoice(
      rewardConflictPrimary,
      rewardConflictPrimaryLabel,
      rewardConflictPrimaryMeta,
      rewardConflictPrimaryBadge,
      'retry',
      'Check my gifts again',
      "We'll check every reward before checkout.",
      true
    );
    configureRewardConflictChoice(
      rewardConflictSecondary,
      rewardConflictSecondaryLabel,
      rewardConflictSecondaryMeta,
      rewardConflictSecondaryBadge,
      'remove_gifts',
      'Remove gifts and continue',
      conflict.discountCodes.length
        ? 'Your current cart discount stays applied.'
        : 'Continue without the unverified gift lines.',
      false
    );
  }

  function openRewardConflict(cart, withProtection, destination, missingCodes, trigger, forceError) {
    if (!rewardConflict || !rewardConflictDialog) return false;
    var competingDiscount = competingDiscountContextForCart(cart);
    var discountCodes = competingDiscount.codes;
    var rewardCodes = rewardCodesForCart(cart);
    var rewardValue = rewardGiftRetailValue(cart);
    var discountValue = competingDiscount.value;
    var giftNames = rewardGiftNames(cart);
    var conflict = {
      cart: cart,
      withProtection: Boolean(withProtection),
      destination: destination,
      missingCodes: missingCodes || rewardCodes,
      rewardCodes: rewardCodes,
      discountCodes: discountCodes,
      rewardValue: rewardValue,
      discountValue: discountValue,
      giftNames: giftNames,
      trigger: trigger || null,
      mode: 'offer_conflict'
    };
    state.pendingRewardConflict = conflict;
    rewardConflict.hidden = false;
    root.classList.add('has-reward-conflict');

    if (forceError || !discountCodes.length) {
      renderRewardConflictError(conflict);
      publishRewardConflictEvent('mma_cart_reward_checkout_blocked', conflict, {
        block_reason: forceError ? 'validation_error' : 'reward_code_not_applicable'
      });
    } else {
      var discountRecommended = discountValue > rewardValue;
      var giftsRecommended = rewardValue > discountValue;
      if (rewardConflictTitle) rewardConflictTitle.textContent = 'Pick the better deal';
      if (rewardConflictCopy) {
        rewardConflictCopy.textContent = 'Your cart discount and gifts cannot be combined. Pick one before checkout. Nothing marked free will become a paid item.';
      }
      configureRewardConflictChoice(
        rewardConflictPrimary,
        rewardConflictPrimaryLabel,
        rewardConflictPrimaryMeta,
        rewardConflictPrimaryBadge,
        'keep_discount',
        'Keep my discount',
        money(discountValue) + ' off with ' + discountCodes.join(' + '),
        discountRecommended
      );
      configureRewardConflictChoice(
        rewardConflictSecondary,
        rewardConflictSecondaryLabel,
        rewardConflictSecondaryMeta,
        rewardConflictSecondaryBadge,
        'keep_gifts',
        'Keep my gifts',
        money(rewardValue) + ' value' + (giftNames.length ? ': ' + giftNames.join(' + ') : ''),
        giftsRecommended
      );
      publishRewardConflictEvent('mma_cart_reward_conflict_detected', conflict, {
        block_reason: 'discount_combination_conflict',
        recommended_choice: discountRecommended ? 'keep_discount' : giftsRecommended ? 'keep_gifts' : 'equal_value'
      });
    }

    window.setTimeout(function () {
      rewardConflictDialog.focus();
    }, 20);
    return true;
  }

  function resolveRewardConflict(action) {
    var conflict = state.pendingRewardConflict;
    if (!conflict || root.classList.contains('is-busy')) return;

    if (action === 'retry') {
      var withProtection = conflict.withProtection;
      var trigger = conflict.trigger;
      closeRewardConflict(false);
      prepareCheckout(withProtection, trigger);
      return;
    }

    if (action !== 'keep_discount' && action !== 'keep_gifts' && action !== 'remove_gifts') return;
    setBusy(true);
    publishRewardConflictEvent('mma_cart_reward_conflict_choice', conflict, {
      selected_choice: action
    });

    var resolution;
    var prepareResolution = cartFetch('/cart.js').then(function (cart) {
      return syncProtectionForRewardConflict(cart, conflict.withProtection);
    });
    if (action === 'keep_gifts') {
      resolution = prepareResolution.then(function () {
        return applyDiscountCodeSet(conflict.rewardCodes);
      }).then(clearRewardGiftCompetingDiscount).then(function () {
        return applyDiscountCodeSet(conflict.rewardCodes);
      }).then(function (cart) {
        var missing = missingRewardCodes(cart);
        if (missing.length) {
          throw new Error('Reward codes were not accepted: ' + missing.join(','));
        }
        return cart;
      });
    } else {
      resolution = prepareResolution.then(removeRewardGiftLines).then(function () {
        return applyDiscountCodeSet(conflict.discountCodes);
      });
    }

    resolution.then(function (cart) {
      state.cart = cart;
      render(cart);
      closeRewardConflict(false);
      publishRewardConflictEvent('mma_cart_reward_conflict_resolved', conflict, {
        selected_choice: action
      });
      window.location.href = checkoutUrlWithDiscountCodes(
        conflict.destination,
        action === 'keep_gifts' ? conflict.rewardCodes : conflict.discountCodes
      );
    }).catch(function (error) {
      console.warn('MMA cart reward conflict could not be resolved.', error);
      setBusy(false);
      renderRewardConflictError(conflict);
      publishRewardConflictEvent('mma_cart_reward_checkout_blocked', conflict, {
        block_reason: 'resolution_failed',
        selected_choice: action,
        error_message: text(error && error.message || error)
      });
    });
  }

  function captureCheckoutUrl(destination) {
    var raw = text(destination || '/checkout');
    var email = '';
    var phone = '';
    try {
      email = text(
        window.sessionStorage.getItem('mma_capture_checkout_email')
        || window.sessionStorage.getItem('mma_blackjack_checkout_email')
        || ''
      ).trim().toLowerCase();
      phone = text(window.sessionStorage.getItem('mma_blackjack_checkout_phone') || '').replace(/\D/g, '');
    } catch (error) {
      return raw;
    }

    var hasEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (phone.length === 10) phone = '1' + phone;
    var hasPhone = phone.length === 11 && phone.charAt(0) === '1';
    if (!hasEmail && !hasPhone) return raw;

    try {
      var url = new URL(raw, window.location.origin);
      if (url.origin === window.location.origin) {
        var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        url.pathname = text(routesRoot).replace(/\/?$/, '/') + 'cart/checkout';
      }
      if (hasEmail) url.searchParams.set('checkout[email]', email);
      if (hasPhone) url.searchParams.set('checkout[shipping_address][phone]', '+' + phone);
      if (url.origin === window.location.origin) return url.pathname + url.search + url.hash;
      return url.toString();
    } catch (error) {
      return raw;
    }
  }

  function checkoutUrl() {
    var destination = config.checkoutUrl || '/checkout';
    if (
      window.MmaBlackjackCheckout
      && typeof window.MmaBlackjackCheckout.enhanceUrl === 'function'
    ) {
      destination = window.MmaBlackjackCheckout.enhanceUrl(destination);
    }
    return captureCheckoutUrl(destination);
  }

  function checkoutUrlWithDiscountCodes(destination, codes) {
    var normalizedCodes = mergeDiscountCodes([], codes || []);
    if (!normalizedCodes.length) return destination;
    try {
      var url = new URL(destination, window.location.origin);
      url.searchParams.set('discount', normalizedCodes.join(','));
      if (url.origin === window.location.origin) return url.pathname + url.search + url.hash;
      return url.toString();
    } catch (error) {
      return destination;
    }
  }

  function prepareCheckout(withProtection, trigger) {
    if (!state.cart || root.classList.contains('is-busy')) return;
    var destination = checkoutUrl();
    var cartBeforeCheckout = state.cart;
    var shoppingCodesBeforeCheckout = shoppingDiscountCodesForCart(cartBeforeCheckout);
    if (shoppingCodesBeforeCheckout.length > 1) {
      setBusy(true);
      normalizeShoppingDiscountCodesForCart(cartBeforeCheckout).then(function (cart) {
        state.cart = cart;
        render(cart);
        setBusy(false);
        prepareCheckout(withProtection, trigger);
      }).catch(function (error) {
        console.warn('MMA cart Shopping code normalization failed.', error);
        setBusy(false);
        if (rewardCopy) rewardCopy.textContent = 'Checkout is paused while we verify your promotion.';
      });
      return;
    }
    var hasClaimedRewards = rewardGiftItems(cartBeforeCheckout).length > 0;
    var immediateDiscountContext = competingDiscountContextForCart(cartBeforeCheckout);
    var immediateChoiceCodes = immediateDiscountContext.codes.filter(discountCodeRequiresRewardChoice);
    if (hasClaimedRewards && immediateChoiceCodes.length) {
      openRewardConflict(
        cartBeforeCheckout,
        withProtection,
        destination,
        rewardCodesForCart(cartBeforeCheckout),
        trigger,
        false
      );
      return;
    }
    var cartBeforeDiscountMerge = null;
    var preexistingDiscountCodes = [];
    var requiredChoiceCodes = [];
    setBusy(true);

    syncRewardGifts(cartBeforeCheckout).then(function (cart) {
      var existing = protectionItem(cart);
      if (withProtection) {
        return ensureProtection(cart, 'cart_drawer_primary_cta');
      }
      if (!existing) return cart;
      return changeLineRaw(existing.key, 0);
    }).then(function () {
      setBusy(true);
      return cartFetch('/cart.js');
    }).then(function (cart) {
      return normalizeShoppingDiscountCodesForCart(cart);
    }).then(function (cart) {
      cartBeforeDiscountMerge = cart;
      preexistingDiscountCodes = competingDiscountContextForCart(cart).codes;
      requiredChoiceCodes = preexistingDiscountCodes.filter(discountCodeRequiresRewardChoice);
      return applyRewardDiscountCodes(cart);
    }).then(function (cart) {
      state.cart = cart;
      render(cart);
      var missingRewards = missingRewardCodes(cart);
      var displacedCodes = missingDiscountCodes(cart, preexistingDiscountCodes);
      if (requiredChoiceCodes.length || missingRewards.length || displacedCodes.length) {
        setBusy(false);
        var conflictCart = cartBeforeDiscountMerge || cart;
        var blockedRewards = missingRewards.length ? missingRewards : rewardCodesForCart(conflictCart);
        if (!openRewardConflict(conflictCart, withProtection, destination, blockedRewards, trigger, false) && rewardCopy) {
          rewardCopy.textContent = 'Checkout is paused until your free gifts are verified.';
        }
        return;
      }
      var checkoutCodes = hasClaimedRewards
        ? mergeDiscountCodes(preexistingDiscountCodes, rewardCodesForCart(cart))
        : [];
      window.location.href = checkoutUrlWithDiscountCodes(destination, checkoutCodes);
    }).catch(function (error) {
      console.warn('MMA cart checkout preparation failed.', error);
      setBusy(false);
      if (hasClaimedRewards || rewardGiftItems(state.cart).length) {
        if (!openRewardConflict(state.cart, withProtection, destination, rewardCodesForCart(state.cart), trigger, true) && rewardCopy) {
          rewardCopy.textContent = 'Checkout is paused until your free gifts are verified.';
        }
        return;
      }
      window.location.href = destination;
    });
  }

  function captureCheckoutChoice(event) {
    var protectedTrigger = event.target.closest('[data-mma-checkout-protected]');
    var plainTrigger = event.target.closest('[data-mma-checkout-plain]');
    var trigger = protectedTrigger || plainTrigger;
    if (!trigger || !root.contains(trigger)) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    prepareCheckout(Boolean(protectedTrigger), trigger);
  }

  function syncProtectionForRewardConflict(cart, withProtection) {
    var existing = protectionItem(cart);
    if (!withProtection) {
      return existing ? changeLineRaw(existing.key, 0) : Promise.resolve(cart);
    }

    var target = protectionVariantForCart(cart);
    if (!target || !target.id) return Promise.resolve(cart);
    if (existing && Number(existing.variant_id || existing.id) === Number(target.id) && Number(existing.quantity || 1) === 1) {
      return Promise.resolve(cart);
    }

    var add = function () {
      return cartFetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({
          id: Number(target.id),
          quantity: 1,
          properties: {
            _source: 'cart_drawer_reward_conflict_choice',
            _protection_fee: money(target.price),
            _protection_rule: 'default_1_percent_4_nearest_0_50'
          }
        })
      }).then(function () {
        return cartFetch('/cart.js');
      });
    };
    return existing ? changeLineRaw(existing.key, 0).then(add) : add();
  }

  function ensureProtection(cart, source) {
    var target = protectionVariantForCart(cart);
    var existing = protectionItem(cart);
    if (!target || !target.id) return Promise.resolve(cart);
    if (existing && Number(existing.variant_id || existing.id) === Number(target.id) && Number(existing.quantity || 1) === 1) {
      return Promise.resolve(cart);
    }
    var add = function () {
      return addVariant(target.id, 1, {
        _source: source,
        _protection_fee: money(target.price),
        _protection_rule: 'default_1_percent_4_nearest_0_50'
      });
    };
    if (!existing) return add();
    return changeLine(existing.key, 0).then(add);
  }

  document.addEventListener('click', function (event) {
    var exclusionToggle = event.target.closest('[data-mma-shipping-exclusion-tooltip] button');
    if (exclusionToggle && root.contains(exclusionToggle)) {
      event.preventDefault();
      event.stopPropagation();
      toggleShippingExclusionTooltip(exclusionToggle);
      return;
    }

    if (root.contains(event.target) && !event.target.closest('[data-mma-shipping-exclusion-tooltip]')) {
      closeShippingExclusionTooltips(root);
    }

    var cartLink = event.target.closest('a[href]');
    if (cartLink && !cartLink.hasAttribute('data-mma-cart-allow-page')) {
      var href = cartLink.getAttribute('href') || '';
      var isPlainClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        url = null;
      }
      if (
        isPlainClick &&
        url &&
        url.origin === window.location.origin &&
        url.pathname === (config.cartUrl || '/cart') &&
        window.location.pathname !== (config.cartUrl || '/cart') &&
        !cartLink.closest('[data-mma-cart-drawer]')
      ) {
        event.preventDefault();
        openDrawer();
        return;
      }
    }

    var open = event.target.closest('[data-mma-cart-open]');
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest('[data-mma-upsell-details-close]')) {
      event.preventDefault();
      var closeReason = event.target.closest('.mma-cart__quick-view-scrim') ? 'scrim' : 'close_button';
      closeUpsellDetails(closeReason);
      return;
    }

    if (event.target.closest('[data-mma-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.closest('[data-mma-reward-conflict-close]')) {
      event.preventDefault();
      closeRewardConflict(true);
      return;
    }

    var rewardConflictChoice = event.target.closest('[data-mma-reward-conflict-action]');
    if (rewardConflictChoice) {
      event.preventDefault();
      resolveRewardConflict(rewardConflictChoice.getAttribute('data-mma-reward-conflict-action'));
      return;
    }

    if (event.target.closest('[data-mma-remove-cancel]')) {
      event.preventDefault();
      closeRemoveConfirm();
      return;
    }

    if (event.target.closest('[data-mma-remove-confirm-action]')) {
      event.preventDefault();
      confirmRemove();
      return;
    }

    var item = event.target.closest('[data-mma-cart-key]');
    if (item) {
      var key = item.getAttribute('data-mma-cart-key');
      var currentItem = visibleItems(state.cart).find(function (cartItem) {
        return cartItem.key === key;
      });
      if (!currentItem) return;
      var qtyButton = event.target.closest('[data-mma-qty]');
      if (qtyButton) {
        event.preventDefault();
        if (root.classList.contains('is-busy') || isGloveGift(currentItem) || isRewardGift(currentItem)) {
          refreshCart();
          return;
        }
        var nextQty = Math.max(0, Number(currentItem.quantity || 0) + Number(qtyButton.getAttribute('data-mma-qty')));
        changeLine(key, nextQty);
        return;
      }
      if (event.target.closest('[data-mma-remove]')) {
        event.preventDefault();
        openRemoveConfirm(currentItem);
        return;
      }
    }

    var detailsTrigger = event.target.closest('[data-mma-upsell-details-open]');
    if (detailsTrigger) {
      event.preventDefault();
      var detailsHandle = detailsTrigger.getAttribute('data-mma-upsell-details-open');
      var detailsProduct = state.upsells.find(function (product) {
        return product.handle === detailsHandle;
      });
      if (detailsProduct) openUpsellDetails(detailsProduct, detailsTrigger);
      return;
    }

    var fullDetailsLink = event.target.closest('[data-mma-upsell-full-details]');
    if (fullDetailsLink && state.quickViewProduct) {
      publishUpsellEvent('mma_cart_upsell_full_details_clicked', state.quickViewProduct, selectedUpsellVariant(state.quickViewProduct), {
        detail_source: 'quick_details'
      });
      return;
    }

    var rewardClaim = event.target.closest('[data-mma-claim-reward]');
    if (rewardClaim) {
      event.preventDefault();
      var gift = rewardGiftByTier(rewardClaim.getAttribute('data-mma-claim-reward'));
      claimRewardGift(gift);
      return;
    }

    var add = event.target.closest('[data-mma-add-upsell]');
    if (add) {
      var upsellHandle = add.getAttribute('data-mma-add-upsell');
      var upsellProduct = state.upsells.find(function (product) {
        return product.handle === upsellHandle;
      });
      if (!upsellProduct) return;
      var detailSource = add.closest('[data-mma-upsell-details]') ? 'quick_details' : 'card';
      var upsellVariant = selectedUpsellVariant(upsellProduct);
      publishUpsellEvent('mma_cart_upsell_added', upsellProduct, upsellVariant, { detail_source: detailSource });
      var addRequest = addVariant(upsellVariant.id, 1, {
        _mma_source: 'cart_drawer_upsell',
        _mma_campaign: 'custom_cart_drawer',
        _mma_upsell_handle: upsellProduct.handle,
        _mma_upsell_product_id: String(upsellProduct.id),
        _mma_upsell_variant_id: String(upsellVariant.id),
        _mma_upsell_variant_title: text(upsellVariant.title || ''),
        _mma_upsell_slot: String(state.upsellIndex + 1),
        _mma_upsell_rank: String(state.upsellIndex + 1) + '/' + state.upsells.length,
        _mma_upsell_role: text((upsellProduct._mmaRecommendation || {}).role || productRole(upsellProduct)),
        _mma_upsell_reason: text((upsellProduct._mmaRecommendation || {}).reason || ''),
        _mma_upsell_closes_free_shipping: String(Boolean((upsellProduct._mmaRecommendation || {}).closesFreeShipping)),
        _mma_upsell_threshold_gap: money((upsellProduct._mmaRecommendation || {}).thresholdGap || 0),
        _mma_reward_campaign: text(config.rewardCampaign || ''),
        _mma_cart_triggers: cartTriggerCategories(state.cart),
        _mma_detail_source: detailSource,
        _mma_tracking_version: 'cart_drawer_20260819'
      });
      if (detailSource === 'quick_details' && addRequest && typeof addRequest.then === 'function') {
        addRequest.then(function () {
          closeUpsellDetails('added_to_cart');
        });
      }
      return;
    }

    if (event.target.closest('[data-mma-upsell-prev]')) {
      state.upsellIndex = (state.upsellIndex - 1 + state.upsells.length) % state.upsells.length;
      renderUpsells(state.cart);
      return;
    }

    if (event.target.closest('[data-mma-upsell-next]')) {
      state.upsellIndex = (state.upsellIndex + 1) % state.upsells.length;
      renderUpsells(state.cart);
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var rewardVariantSelect = event.target.closest('[data-mma-reward-variant]');
    if (rewardVariantSelect) {
      updateRewardVariantSelection(rewardVariantSelect);
      return;
    }

    var variantSelect = event.target.closest('[data-mma-upsell-variant]');
    if (!variantSelect) return;
    var detailSource = variantSelect.closest('[data-mma-upsell-details]') ? 'quick_details' : 'card';
    updateUpsellVariantSelection(variantSelect);
    var upsellHandle = variantSelect.closest('[data-mma-upsell-handle]')?.getAttribute('data-mma-upsell-handle');
    var upsellProduct = state.upsells.find(function (product) {
      return product.handle === upsellHandle;
    });
    if (upsellProduct) {
      publishUpsellEvent('mma_cart_upsell_variant_selected', upsellProduct, selectedUpsellVariant(upsellProduct), {
        detail_source: detailSource
      });
    }
  });

  window.addEventListener('click', captureCheckoutChoice, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && rewardConflict && !rewardConflict.hidden) {
      closeRewardConflict(true);
      return;
    }

    if (event.key === 'Tab' && rewardConflict && !rewardConflict.hidden && rewardConflictDialog) {
      var conflictFocusable = Array.prototype.slice.call(rewardConflictDialog.querySelectorAll('button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!conflictFocusable.length) {
        event.preventDefault();
        rewardConflictDialog.focus();
        return;
      }
      var conflictFirst = conflictFocusable[0];
      var conflictLast = conflictFocusable[conflictFocusable.length - 1];
      if (event.shiftKey && document.activeElement === conflictFirst) {
        event.preventDefault();
        conflictLast.focus();
      } else if (!event.shiftKey && document.activeElement === conflictLast) {
        event.preventDefault();
        conflictFirst.focus();
      }
      return;
    }

    if (event.key === 'Escape' && upsellDetails && !upsellDetails.hidden) {
      closeUpsellDetails('escape');
      return;
    }

    if (event.key === 'Tab' && upsellDetails && !upsellDetails.hidden && upsellDetailsSheet) {
      var focusable = Array.prototype.slice.call(upsellDetailsSheet.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) {
        event.preventDefault();
        upsellDetailsSheet.focus();
        return;
      }
      var firstFocusable = focusable[0];
      var lastFocusable = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
      return;
    }

    if (event.key === 'Escape' && root.querySelector('[data-mma-shipping-exclusion-tooltip].is-open')) {
      closeShippingExclusionTooltips(root);
      return;
    }

    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      if (removeConfirm && !removeConfirm.hidden) {
        closeRemoveConfirm();
        return;
      }
      closeDrawer();
    }
  });

  document.addEventListener('ajaxProduct:added', function () {
    openDrawer();
  });

  ['cart:update', 'cart:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      if (root.classList.contains('is-open')) refreshCart();
    });
  });

  window.MMACartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart
  };
})();
